import {
  TextField,
  Box,
  Grid,
  Typography,
  useTheme,
  FormControl,
  Button,
  IconButton,
  Stack,
  Tooltip,
  InputLabel,
  Select,
  MenuItem,
  Breadcrumbs,
  LinearProgress,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  FormLabel,
  Checkbox,
  Avatar,
} from "@mui/material";
import { Field } from "formik";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import {
  dataGridHeaderFooterHeight,
  dataGridRowHeight,
  formGap,
} from "../../../ui-components/global/utils";
import { PDFDownloadLink } from "@react-pdf/renderer";
import useMediaQuery from "@mui/material/useMediaQuery";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import { Formik } from "formik";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import {
  getFetchData,
  postData,
  requestMail,
  scrumUpdateget,
  scrumUpdatepostData,
} from "../../../store/reducers/Formapireducer";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import React, { useEffect, useRef, useState } from "react";
import { LoadingButton } from "@mui/lab";
import Swal from "sweetalert2";
import { useProSidebar } from "react-pro-sidebar";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { tokens } from "../../../Theme";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import FileListPopup from "../../../ui-components/FIleViewDialog";
import FileUploadIconButton from "../../../ui-components/FileUploadButton";
import { attachmentPost } from "../../../store/reducers/LoginReducer";
import ViewListIcon from "@mui/icons-material/ViewList";
import GradingIcon from "@mui/icons-material/Grading";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import axios from "axios";
import store from "../../..";
import {
  CheckinAutocomplete,
  DailyTaskAutocomplete,
  Employeeautocomplete,
  MultiFormikOptimizedAutocomplete,
} from "../../../ui-components/global/Autocomplete";
import * as Yup from "yup";
import Chart from "react-apexcharts";
import CryptoJS from "crypto-js";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { fetchListview } from "../../../store/reducers/Listviewapireducer";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import EditIcon from "@mui/icons-material/Edit";
import { EditOutlined, Visibility } from "@mui/icons-material";
import TaskupdatePDF from "../../reports/Taskupdatepdf";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { fetchExplorelitview } from "../../../store/reducers/Explorelitviewapireducer";
import { getConfig } from "../../../config";
import TaskupdateExcel from "../../reports/TaskupdateExcel";
import { FaFileExcel } from "react-icons/fa";



function getLocalDate() {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const date = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${date}`;
}

const KEY = CryptoJS.enc.Utf8.parse("1234567890123456"); // 16-byte key
const IV = CryptoJS.enc.Utf8.parse("1234567890123456"); // 16-byte IV

export function encryptDataUrlSafe(plainText) {
  const encrypted = CryptoJS.AES.encrypt(plainText, KEY, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString(); // Standard base64

  // Convert to URL-safe base64
  return encrypted.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

export function decryptData(encryptedBase64) {
  const decrypted = CryptoJS.AES.decrypt(
    { ciphertext: CryptoJS.enc.Base64.parse(encryptedBase64) },
    KEY,
    {
      iv: IV,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );

  return decrypted.toString(CryptoJS.enc.Utf8); // Original string
}


const EditDailytask = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  let params = useParams();
  const dispatch = useDispatch();
  var recID = params.id;
  var compID = sessionStorage.getItem("companyId");
  var mode = params.Mode;
  // var accessID = params.accessID;
  console.log(params.accessID, "--accessID Fibding");

  var accessID = "TR132";
  const parentID = params.filtertype;
  const data = useSelector((state) => state.formApi.Data);
  const isManager = sessionStorage.getItem("isManager");
  const [inputValue, setInputValue] = useState(0);
  const fromDate = useSelector((state) => state.listviewApi.fromDate);
  console.log("🚀 ~ Listview ~ fromDate:", fromDate);
  const toDate = useSelector((state) => state.listviewApi.toDate);
  const Status = useSelector((state) => state.formApi.Status);
  console.log("🚀 ~ EditDailytask ~ Status:", Status);
  const Msg = useSelector((state) => state.formApi.msg);
  const isLoading = useSelector((state) => state.formApi.postLoading);
  const getLoading = useSelector((state) => state.formApi.getLoading);
  const EMPID = sessionStorage.getItem("EmpId");
  const { toggleSidebar, broken, rtl } = useProSidebar();
  const location = useLocation();
  const { ClickedDate } = location.state || {};
  const state = location.state || {};
  console.log(state.DailyTaskDate, "-----------------");
  const today = new Date();
  const curdate = today.toISOString().split("T")[0];
  const EmpName = sessionStorage.getItem("EmpName");
  const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [error, setError] = useState("");
  const rowSx = { height: 36, "& td, & th": { py: 0.5 } };
  const [files, setFiles] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = React.useState(10);
  const [rowCount, setRowCount] = useState(0);
  const [showImage, setShowImage] = useState(mode == "IM" ? true : false);
  const isReadOnlyAssigned = data.Status === "AS";
  const scrumget = useSelector((state) => state.formApi.scrumget);
  const [errorMsgData, setErrorMsgData] = useState(null);
  const [validationSchema, setValidationSchema] = useState(null);
  const [validationSchema2, setValidationSchema2] = useState(null);
  const [validationSchema3, setValidationSchema3] = useState(null);
  const [validationSchema4, setValidationSchema4] = useState(null);
  const [validationSchema5, setValidationSchema5] = useState(null);
  const [selectedmiles, setSelectedMiles] = useState(null);
  const [selectedOS, setSelectedOS] = useState(null);
  const [selectedAct, setSelectedAct] = useState(null);
  // const milestoneID = selectedmiles.map((miles) => miles.RecordID).join(",");
  // const OprStagID = selectedOS.map((opstg) => opstg.RecordID).join(",");
  // const ActvitID = selectedAct.map((actsid) => actsid.RecordID).join(",");
  const [showMore, setShowMore] = React.useState(false);
  const [oldSpent, setOldSpent] = useState(0);
  const [show, setScreen] = React.useState("0");
  // var secondaryCurrentPage = parseInt(
  //   sessionStorage.getItem("secondaryCurrentPage")
  // );
  // const [page, setPage] = React.useState(secondaryCurrentPage);
  const TaskSource = data.TaskSource;
  const commentsRef = useRef(null);
  const SubscriptionCode = sessionStorage.getItem("SubscriptionCode");
  const is003Subscription = SubscriptionCode.endsWith("003");
  console.log(SubscriptionCode, is003Subscription, "SubscriptionCode");



  const HeaderImg = sessionStorage.getItem("CompanyHeader");
  const FooterImg = sessionStorage.getItem("CompanyFooter");
  const config = getConfig();
  const baseurl1 = config.UAAM_URL;
  console.log("HeaderImg", HeaderImg, FooterImg);

  const getempattach = config.BASE_URL;

  var userimg = store.getState().globalurl.imageUrl;
  if (mode == "A") {
    userimg = userimg + "Defaultimg.jpg";
  } else {
    if (
      data.ImageName == undefined ||
      data.ImageName == null ||
      data.ImageName == ""
    ) {
      userimg = userimg + "Defaultimg.jpg";
    } else {
      userimg = userimg + data.ImageName;
    }
  }
  const explorelistViewData = useSelector(
    (state) => state.exploreApi.explorerowData
  );
  const explorelistViewcolumn = useSelector(
    (state) => state.exploreApi.explorecolumnData
  );
  console.log(explorelistViewcolumn, "rowsss");
  console.log(explorelistViewData, "rowsss22");

  const exploreLoading = useSelector((state) => state.exploreApi.loading);
  const screenChange = (event) => {
    setScreen(event.target.value);
    // console.log(accessID,"accessID")
    if (event.target.value == "0") {
      console.log(accessID, "accessID");
      dispatch(getFetchData({ accessID, get: "get", recID }));

      // dispatch(getFetchData({ "get", recID}));
    }
    if (event.target.value == "1") {
      dispatch(
        fetchExplorelitview(
          "TR322",
          "Product",
          `CompanyID='${compID}' AND DailyTaskID='${recID}' AND Type='Product'`,
          ""
        )
      );
      selectCellRowData({ rowData: {}, mode: "A", field: "", type: "product" });
    }
    if (event.target.value == "2") {
      dispatch(
        fetchExplorelitview(
          "TR322",
          "Material",
          `CompanyID='${compID}' AND DailyTaskID='${recID}' AND Type='Material'`,
          ""
        )
      );
      selectCellRowData({
        rowData: {},
        mode: "A",
        field: "",
        type: "material",
      });
    }
    if (event.target.value == "3") {
      dispatch(
        fetchExplorelitview(
          "TR322",
          "Service",
          `CompanyID='${compID}' AND DailyTaskID='${recID}' AND Type='Service'`,
          ""
        )
      );
      selectCellRowData({ rowData: {}, mode: "A", field: "", type: "service" });
    }
    if (event.target.value == "4") {
      dispatch(
        fetchExplorelitview(
          "TR322",
          "Machinery",
          `CompanyID='${compID}' AND DailyTaskID='${recID}' AND Type='Machinery'`,
          ""
        )
      );
      selectCellRowData({ rowData: {}, mode: "A", field: "", type: "machinery" });
    }
  };

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/validationcms.json")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch validationcms.json");
        return res.json();
      })
      .then((data) => {
        setErrorMsgData(data);
        const schema = Yup.object().shape({
          ProName: Yup.object().required(data.Dailytask.ProName).nullable(),
          date: Yup.string().required(data.Dailytask.date),
          TargetDate: Yup.string().required(data.Dailytask.TargetDate),
          TaskType: Yup.string().required(data.Dailytask.TaskType),
          TaskPriority: Yup.string().required(data.Dailytask.TaskPriority),
          estimatedHours: Yup.string().required(data.Dailytask.estimatedHours),
          // actualHours: Yup.string().required(data.Dailytask.actualHours),
          description: Yup.string().required(data.Dailytask.description),
          Comment: Yup.string().trim().required(data.Dailytask.Comment),
        });

        const schema4 = Yup.object().shape({
          productItems: Yup.object()
            .nullable()
            .test(
              "productItems-required",
              data.ScrumTask.productItems,
              (value) => value && value.RecordID && value.RecordID !== ""
            ),

          // productUnit: Yup.string().required(data.ScrumTask.productUnit),
          // productQty: Yup.string().required(data.ScrumTask.productQty),
          // productRate: Yup.string().required(data.ScrumTask.productRate),
        });
        const schema2 = Yup.object().shape({
          materialItems: Yup.object()
            .nullable()
            .test(
              "materialItems-required",
              data.ScrumTask.materialItems,
              (value) => value && value.RecordID && value.RecordID !== ""
            ),

          // materialUnit: Yup.string().required(data.ScrumTask.materialUnit),
          // materialQty: Yup.string().required(data.ScrumTask.materialQty),
          // materialRate: Yup.string().required(data.ScrumTask.materialRate),
        });
        const schema3 = Yup.object().shape({
          serviceItems: Yup.object()
            .nullable()
            .test(
              "serviceItems-required",
              data.ScrumTask.serviceItems,
              (v) => !!v?.RecordID
            ),

          // serviceUnit: Yup.string().required(data.ScrumTask.serviceUnit),
          // serviceQty: Yup.string().required(data.ScrumTask.serviceQty),
          // serviceRate: Yup.string().required(data.ScrumTask.serviceRate),
        });

        const schema5 = Yup.object().shape({
          machineryItems: Yup.object({
            RecordID: Yup.string().required("Please Select an Item"),
          })
            .nullable()
            .typeError("Please Select an Item")
            .required("Please Select an Item"),
        });

        setValidationSchema(schema);
        setValidationSchema2(schema2);
        setValidationSchema3(schema3);
        setValidationSchema4(schema4);
        setValidationSchema5(schema5)
      })
      .catch((err) => console.error("Error loading validationcms.json:", err));
  }, []);
  useEffect(() => {
    // if (mode === "U") {
    dispatch(scrumUpdateget({ action: "get", recID }));
    // }
    dispatch(getFetchData({ accessID, get: "get", recID })).then((res) => {
      console.log(res, "response");
      console.log(data.EmployeesID, "response");
      var url = store.getState().globalurl.empGetAttachmentUrl;

      axios
        .get(url, {
          params: {
            // empId: data.EmployeesID,
            empId: EMPID,
            appId: recID,
          },
        })
        .then((response) => {
          setFiles(response.data);
        })
        .catch((err) => {
          setError("Failed to fetch attachments.");
          console.error(err);
        })
        .finally(() => setLoading(false));
    });
  }, []);
  //For navigation from sprint
  // useEffect(() => {
  //   if (state.initialShow) {
  //     const showValue = state.initialShow;
  //     console.log(showValue, "showValue from location.state");
  //     setScreen(showValue);
  //     // if(showValue){
  //     // screenChange();
  //     // }
  //   }
  // }, [data]);


  const [funMode, setFunMode] = useState("A");
  const [laomode, setLaoMode] = useState("A");
  var secondaryCurrentPage = parseInt(
    sessionStorage.getItem("secondaryCurrentPage")
  );

  console.log(data.Status, "status check...........")
  const [page, setPage] = React.useState(secondaryCurrentPage);

  const [itemProductData, setItemProductData] = useState({
    recordID: "",
    DailyTaskID: "",
    CrmItemsID: "",
    CrmItemGroupID: "",
    CrmItemCategoryID: "",
    Uom: "",
    Qty: "",
    Rate: "",
    Amount: "",
    Type: "",
    Comments: "",
  });
  const [itemMaterialData, setItemMaterialData] = useState({
    recordID: "",
    DailyTaskID: "",
    CrmItemsID: "",
    CrmItemGroupID: "",
    CrmItemCategoryID: "",
    Uom: "",
    Qty: "",
    Rate: "",
    Amount: "",
    Type: "",
    Comments: "",
  });
  const [itemServiceData, setItemServiceData] = useState({
    recordID: "",
    DailyTaskID: "",
    CrmItemsID: "",
    CrmItemGroupID: "",
    CrmItemCategoryID: "",
    Uom: "",
    Qty: "",
    Rate: "",
    Amount: "",
    Type: "",
    Comments: "",
  });
  // ***************  DAILY TASK  LOOKUP  *************** //
  // const selectCellRowData = ({ rowData, mode, field, setFieldValue }) => {
  //   setFunMode(mode);

  //   if (mode === "A") {
  //     setItemProductData({
  //       recordID: "",
  //       DailyTaskID: "",
  //       CrmItemsID: "",
  //       CrmItemGroupID: "",
  //       CrmItemCategoryID: "",
  //       Uom: "",
  //       Qty: "",
  //       Rate: "",
  //       Amount: "",
  //       Type: "",
  //       Comments: "",
  //     });

  //     if (setFieldValue) {
  //       setFieldValue("items", { RecordID: "", Code: "", Name: "" });
  //       setFieldValue("itemCategoryID", "");
  //       setFieldValue("itemGroupID", "");
  //       setFieldValue("unit", "");
  //       setFieldValue("productRate", "");
  //       setFieldValue("productQty", "");
  //       setFieldValue("productAmount", "");
  //       setFieldValue("productcomments", "");
  //     }
  //     return;
  //   }

  //   // -------------------- EDIT MODE ---------------------
  //   setItemProductData({
  //     recordID: rowData.RecordID || "",
  //     DailyTaskID: rowData.DailyTaskID || "",
  //     CrmItemsID: rowData.CrmItemsID || "",
  //     CrmItemGroupID: rowData.CrmItemGroupID || "",
  //     CrmItemCategoryID: rowData.CrmItemCategoryID || "",
  //     Uom: rowData.Uom || "",
  //     Qty: rowData.Qty || "",
  //     Rate: rowData.Rate || "",
  //     Amount: rowData.Amount || "",
  //     Type: rowData.Type || "",
  //     Comments: rowData.Comments || "",
  //   });

  //   setFieldValue("items", {
  //     RecordID: rowData.CrmItemsID,
  //     Code: rowData.CrmItemsCode,
  //     Name: rowData.CrmItemsName,
  //   });

  //   setFieldValue("itemCategoryID", rowData.CrmItemCategoryID || "");
  //   setFieldValue("itemGroupID", rowData.CrmItemGroupID || "");
  //   setFieldValue("unit", rowData.Uom || "");
  //   setFieldValue("productRate", rowData.Rate || "");
  //   setFieldValue("productQty", rowData.Qty || "");
  //   setFieldValue("productAmount", rowData.Amount || "");
  //   setFieldValue("productcomments", rowData.Comments || "");
  // };
  // const selectCellRowData = ({ rowData, mode, field, type,setFieldValue }) => {
  //   setFunMode(mode);

  //   const resetObj = {
  //     recordID: "",
  //     DailyTaskID: "",
  //     CrmItemsID: "",
  //     CrmItemGroupID: "",
  //     CrmItemCategoryID: "",
  //     Uom: "",
  //     Qty: "",
  //     Rate: "",
  //     Amount: "",
  //     Type: "",
  //     Comments: "",
  //   };

  //   if (mode === "A") {
  //     if (type === "product") {
  //       setItemProductData(resetObj);
  //       setFieldValue("productItems", { RecordID: "", Code: "", Name: "" });
  //       setFieldValue("productCategoryID", "");
  //       setFieldValue("productGroupID", "");
  //       setFieldValue("productUnit", "");
  //       setFieldValue("productRate", "");
  //       setFieldValue("productQty", "");
  //       setFieldValue("productAmount", "");
  //       setFieldValue("productcomments", "");
  //     }

  //     if (type === "material") {
  //       setItemMaterialData(resetObj);
  //       setFieldValue("materialItems", { RecordID: "", Code: "", Name: "" });
  //       setFieldValue("materialCategoryID", "");
  //       setFieldValue("materialGroupID", "");
  //       setFieldValue("materialUnit", "");
  //       setFieldValue("materialRate", "");
  //       setFieldValue("materialQty", "");
  //       setFieldValue("materialAmount", "");
  //       setFieldValue("materialcomments", "");
  //     }

  //     if (type === "service") {
  //       setItemServiceData(resetObj);
  //       setFieldValue("serviceItems", { RecordID: "", Code: "", Name: "" });
  //       setFieldValue("serviceCategoryID", "");
  //       setFieldValue("serviceGroupID", "");
  //       setFieldValue("serviceUnit", "");
  //       setFieldValue("serviceRate", "");
  //       setFieldValue("serviceQty", "");
  //       setFieldValue("serviceAmount", "");
  //       setFieldValue("servicecomments", "");
  //     }

  //     return;
  //   }

  //   // =========================================================
  //   //                      EDIT MODE
  //   // =========================================================
  //   const selectedData = {
  //     recordID: rowData.RecordID || "",
  //     DailyTaskID: rowData.DailyTaskID || "",
  //     CrmItemsID: rowData.CrmItemsID || "",
  //     CrmItemGroupID: rowData.CrmItemGroupID || "",
  //     CrmItemCategoryID: rowData.CrmItemCategoryID || "",
  //     Uom: rowData.Uom || "",
  //     Qty: rowData.Qty || "",
  //     Rate: rowData.Rate || "",
  //     Amount: rowData.Amount || "",
  //     Type: rowData.Type || "",
  //     Comments: rowData.Comments || "",
  //   };

  //   if (type === "product") setItemProductData(selectedData);
  //   if (type === "material") setItemMaterialData(selectedData);
  //   if (type === "service") setItemServiceData(selectedData);

  //   const itemValue = {
  //     RecordID: rowData.CrmItemsID,
  //     Code: rowData.CrmItemsCode,
  //     Name: rowData.CrmItemsName,
  //   };

  //   // =========================================================
  //   //                  PRODUCT MAP
  //   // =========================================================
  //   if (type === "product") {
  //     setFieldValue("productItems", itemValue);
  //     setFieldValue("productCategoryID", rowData.CrmItemCategoryID || "");
  //     setFieldValue("productGroupID", rowData.CrmItemGroupID || "");
  //     setFieldValue("productUnit", rowData.Uom || "");
  //     setFieldValue("productRate", rowData.Rate || "");
  //     setFieldValue("productQty", rowData.Qty || "");
  //     setFieldValue("productAmount", rowData.Amount || "");
  //     setFieldValue("productcomments", rowData.Comments || "");
  //   }

  //   // =========================================================
  //   //                  MATERIAL MAP
  //   // =========================================================
  //   if (type === "material") {
  //     setFieldValue("materialItems", itemValue);
  //     setFieldValue("materialCategoryID", rowData.CrmItemCategoryID || "");
  //     setFieldValue("materialGroupID", rowData.CrmItemGroupID || "");
  //     setFieldValue("materialUnit", rowData.Uom || "");
  //     setFieldValue("materialRate", rowData.Rate || "");
  //     setFieldValue("materialQty", rowData.Qty || "");
  //     setFieldValue("materialAmount", rowData.Amount || "");
  //     setFieldValue("materialcomments", rowData.Comments || "");
  //   }

  //   // =========================================================
  //   //                  SERVICE MAP
  //   // =========================================================
  //   if (type === "service") {
  //     setFieldValue("serviceItems", itemValue);
  //     setFieldValue("serviceCategoryID", rowData.CrmItemCategoryID || "");
  //     setFieldValue("serviceGroupID", rowData.CrmItemGroupID || "");
  //     setFieldValue("serviceUnit", rowData.Uom || "");
  //     setFieldValue("serviceRate", rowData.Rate || "");
  //     setFieldValue("serviceQty", rowData.Qty || "");
  //     setFieldValue("serviceAmount", rowData.Amount || "");
  //     setFieldValue("servicecomments", rowData.Comments || "");
  //   }
  // };
  const [productdata, setProductdata] = useState({
    recordID: "",
    productUnit: "",
    productItems: "",
    productRate: "",
    productQty: "",
    productAmount: "",
    productcomments: "",
  });
  const [materialdata, setMaterialdata] = useState({
    recordID: "",
    materialUnit: "",
    materialItems: "",
    materialRate: "",
    materialQty: "",
    materialAmount: "",
    materialcomments: "",
  });
  const [servicedata, setServicedata] = useState({
    recordID: "",
    serviceUnit: "",
    serviceItems: "",
    serviceRate: "",
    serviceQty: "",
    serviceAmount: "",
    servicecomments: "",
  });
  const [machinerydata, setMachinerydata] = useState({
    recordID: "",
    machineryUnit: "",
    machineryItems: "",
    machineryRate: "",
    machineryQty: "",
    machineryAmount: "",
    machineryComments: "",
  })


  const selectCellRowData = ({ rowData, mode, field, setFieldValue, type }) => {
    setFunMode(mode);
    setLaoMode(mode);

    if (mode == "A") {
      setProductdata({
        recordID: "",
        productUnit: "",
        productItems: "",
        productRate: "",
        productQty: "",
        productAmount: "",
        productcomments: "",
        // productItems: rowData.CrmItemsID
        //     ? {
        //       RecordID: rowData.CrmItemsID,
        //       Code: rowData.CrmItemsCode || "",
        //       Name: rowData.CrmItemsName || "",
        //     }
        //     : null,
        productAdditionalBillable: "",
      });
      setMaterialdata({
        recordID: "",
        materialUnit: "",
        materialItems: "",
        materialRate: "",
        materialQty: "",
        materialAmount: "",
        materialcomments: "",
        materialAdditionalBillable: "",
      });
      setServicedata({
        recordID: "",
        serviceUnit: "",
        serviceItems: "",
        serviceRate: "",
        serviceQty: "",
        serviceAmount: "",
        servicecomments: "",
        serviceAdditionalBillable: "",
      });
      setMachinerydata({
        recordID: "",
        machineryUnit: "",
        machineryItems: "",
        machineryRate: "",
        machineryQty: "",
        machineryAmount: "",
        machineryComments: "",
        serviceAdditionalBillable: "",
      });
    } else {
      if (field == "action") {
        setProductdata({
          recordID: rowData.RecordID,
          productUnit: rowData.Uom,
          productRate: rowData.Rate,
          productItems: rowData.CrmItemsName,
          productQty: rowData.Qty,
          productAmount: rowData.Amount,
          productcomments: rowData.Comments,
          productItems: rowData.CrmItemsID
            ? {
              RecordID: rowData.CrmItemsID,
              Code: rowData.CrmItemsCode || "",
              Name: rowData.CrmItemsName || "",
            }
            : null,
          productCategoryID: rowData.CrmItemCategoryID,
          productGroupID: rowData.CrmItemGroupID,
          productAdditionalBillable: rowData.AdditionalBillable,
        });
        setFieldValue("productItems", {
          RecordID: rowData.CrmItemsID,
          Code: rowData.CrmItemsCode,
          Name: rowData.CrmItemsName,
        });
        setFieldValue("productCategoryID", {
          productCategoryID: rowData.CrmItemCategoryID,
        });
        setFieldValue("productGroupID", {
          productGroupID: rowData.CrmItemGroupID,
        });

        setMaterialdata({
          recordID: rowData.RecordID,
          materialUnit: rowData.Uom,
          materialRate: rowData.Rate,
          materialItems: rowData.CrmItemsName,
          materialQty: rowData.Qty,
          materialAmount: rowData.Amount,
          materialcomments: rowData.Comments,
          materialItems: rowData.CrmItemsID
            ? {
              RecordID: rowData.CrmItemsID,
              Code: rowData.CrmItemsCode || "",
              Name: rowData.CrmItemsName || "",
            }
            : null,
          materialGroupID: rowData.CrmItemGroupID,
          materialCategoryID: rowData.CrmItemCategoryID,
          materialAdditionalBillable: rowData.AdditionalBillable,
        });
        setFieldValue("materialItems", {
          RecordID: rowData.CrmItemsID,
          Code: rowData.CrmItemsCode,
          Name: rowData.CrmItemsName,
        });

        setFieldValue("materialCategoryID", {
          materialCategoryID: rowData.CrmItemCategoryID,
        });
        setFieldValue("materialGroupID", {
          materialGroupID: rowData.CrmItemGroupID,
        });

        setServicedata({
          recordID: rowData.RecordID,
          serviceUnit: rowData.Uom,
          serviceRate: rowData.Rate,
          serviceItems: rowData.CrmItemsName,
          serviceQty: rowData.Qty,
          serviceAmount: rowData.Amount,
          servicecomments: rowData.Comments,
          serviceItems: rowData.CrmItemsID
            ? {
              RecordID: rowData.CrmItemsID,
              Code: rowData.CrmItemsCode || "",
              Name: rowData.CrmItemsName || "",
            }
            : null,
          serviceGroupID: rowData.CrmItemGroupID,
          serviceCategoryID: rowData.CrmItemCategoryID,
          serviceAdditionalBillable: rowData.AdditionalBillable,
        });
        setFieldValue("serviceItems", {
          RecordID: rowData.CrmItemsID,
          Code: rowData.CrmItemsCode,
          Name: rowData.CrmItemsName,
        });

        setFieldValue("serviceCategoryID", {
          serviceCategoryID: rowData.CrmItemCategoryID,
        });
        setFieldValue("serviceGroupID", {
          serviceGroupID: rowData.CrmItemGroupID,
        });

        //Machinery
        setMachinerydata({
          recordID: rowData.RecordID,
          machineryUnit: rowData.Uom,
          machineryRate: rowData.Rate,
          machineryItems: rowData.CrmItemsName,
          machineryQty: rowData.Qty,
          machineryAmount: rowData.Amount,
          machineryComments: rowData.Comments,
          machineryItems: rowData.CrmItemsID
            ? {
              RecordID: rowData.CrmItemsID,
              Code: rowData.CrmItemsCode || "",
              Name: rowData.CrmItemsName || "",
            }
            : null,
          machineryGroupID: rowData.CrmItemGroupID,
          machineryCategoryID: rowData.CrmItemCategoryID,
          machineryAdditionalBillable: rowData.AdditionalBillable,
        });
        setFieldValue("machineryItems", {
          RecordID: rowData.CrmItemsID,
          Code: rowData.CrmItemsCode,
          Name: rowData.CrmItemsName,
        });

        setFieldValue("machineryGroupID", rowData.CrmItemGroupID);
        setFieldValue("machineryCategoryID", rowData.CrmItemCategoryID);


      }
    }

    console.log(selectCellRowData, "Itemservices");
  };
  const Productinitialvalues = {
    description: data.Name,
    date: data.TaskDate,
    productUnit: productdata.productUnit,
    productRate: productdata.productRate,
    productQty: productdata.productQty || 1,
    productAmount: productdata.productAmount,
    productcomments: productdata.productcomments,
    productItems: productdata.productItems || null,
    productCategoryID: productdata.productCategoryID || null,
    productGroupID: productdata.productGroupID || null,
    productAdditionalBillable:
      productdata.productAdditionalBillable === "Y" ? true : false,
  };
  const Materialinitialvalues = {
    description: data.Name,
    date: data.TaskDate,
    materialUnit: materialdata.materialUnit,
    materialRate: materialdata.materialRate,
    materialQty: materialdata.materialQty || 1,
    materialAmount: materialdata.materialAmount,
    materialcomments: materialdata.materialcomments,
    materialItems: materialdata.materialItems || null,
    materialCategoryID: materialdata.materialCategoryID || null,
    materialGroupID: materialdata.materialGroupID || null,
    materialAdditionalBillable:
      materialdata.materialAdditionalBillable === "Y" ? true : false,
  };
  const Serviceinitialvalues = {
    description: data.Name,
    date: data.TaskDate,
    serviceUnit: servicedata.serviceUnit,
    serviceRate: servicedata.serviceRate,
    serviceQty: servicedata.serviceQty || 1,
    serviceAmount: servicedata.serviceAmount,
    servicecomments: servicedata.servicecomments,
    serviceItems: servicedata.serviceItems || null,
    serviceCategoryID: servicedata.serviceCategoryID || null,
    serviceGroupID: servicedata.serviceGroupID || null,
    serviceAdditionalBillable:
      servicedata.serviceAdditionalBillable === "Y" ? true : false,
  };

  const Machineryinitialvalues = {
    description: data.Name,
    date: data.TaskDate,
    machineryUnit: machinerydata.machineryUnit,
    machineryRate: machinerydata.machineryRate,
    machineryQty: machinerydata.machineryQty || 1,
    machineryAmount: machinerydata.machineryAmount,
    machineryComments: machinerydata.machineryComments,
    machineryItems: machinerydata.machineryItems || null,
    machineryCategoryID: machinerydata.machineryCategoryID || null,
    machineryGroupID: machinerydata.machineryGroupID || null,
    machineryAdditionalBillable:
      machinerydata.machineryAdditionalBillable === "Y" ? true : false,
  }

  const dailyTaskInitialValue = {
    code: "0",
    description: data.Name,
    // date: params.Date || ClickedDate || curdate || data.TaskDate, // Ensures initial date follows DD-MM-YYYY
    date: data.TaskDate ? data.TaskDate : curdate,
    status:
      mode === "A"
        ? "I"
        : mode == "C"
          ? "C"
          : mode == "P"
            ? "I"
            : mode == "B"
              ? "B"
              : mode == "UB"
                ? "I"
                : data.Status,
    Comment: data.Comments,
    sortOrder: data.SortOrder,
    disable: data.Disable === "Y",
    ProName: data.ProjectID
      ? { RecordID: data.ProjectID, Name: data.ProjectName }
      : null,
    Milestone: data.MilestonesID
      ? { RecordID: data.MilestonesID, Name: data.MilestonesName }
      : null,
    OperationStage:
      data.OperationstageID && data.OperationstageID !== "0"
        ? { RecordID: data.OperationstageID, Name: data.OperationstageName }
        : null,
    Activities:
      data.ActivityID && data.ActivityID !== "0"
        ? { RecordID: data.ActivityID, Name: data.ActivityName }
        : null,
    estimatedHours: data.Estimatehourse,
    actualHours: data.ActualHourse,
    SpentHours: data.SpentHours,
    empDate: data.TransferDate,
    employee: data.ToEmployeeID
      ? { RecordID: data.ToEmployeeID, Name: data.ToEmployeeName }
      : null,
    blockedcomment: data.BlockedComments,
    blockedDate: data.BlockedDate,
    TaskPriority: data.TaskPriority,
    TargetDate: data.TargetDate ? data.TargetDate : getLocalDate(),
    TaskType:
      data.TaskType == "Normal"
        ? "Normal"
        : data.TaskType == "Learning&development"
          ? "Learning&development"
          : data.TaskType == "Research&development"
            ? "Research&development"
            : data.TaskType == "Bug"
              ? "Bug"
              : data.TaskType == "Improvements"
                ? "Improvements"
                : data.TaskType == "Up-skill"
                  ? "Up-skill"
                  : data.TaskType == "Minutes of Meeting"
                    ? "Minutes of Meeting"
                    : data.TaskType == "Documentation"
                      ? "Documentation"
                      : data.TaskType == "Script"
                        ? "Script"
                        : "Normal",
    ManagerComments: data.ManagerComments,
  };

  const convertToDDMMYYYY = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };
  const formattedDate = convertToDDMMYYYY(data.TaskDate);
  const fromStateDate = convertToDDMMYYYY(fromDate);
  console.log("🚀 ~ EditDailytask ~ fromStateDate:", fromStateDate);
  console.log(data.TaskDate, "");

  const DTSaveFn = async (values) => {
    let action = mode === "A" ? "insert" : "update";
    const isCheck = values.disable ? "Y" : "N";

    const idata = {
      parentID: parentID || 0,
      RecordID: recID,
      Code: "0",
      Name: values.description,
      TaskDate: values.date,
      Estimatehourse: values.estimatedHours,
      ActualHourse: values.actualHours || 0,
      Status:
        isReadOnlyAssigned || mode == "P"
          ? "I"
          : mode == "C"
            ? "C"
            : values.status,
      Comments: values.Comment.replace(/\s+/g, " ").trim(),
      SortOrder: "0",
      Disable: isCheck,
      EmpDate: values.empDate || "",
      FromEmployeeID: EMPID,
      EmployeesID: EMPID,
      ToEmployeeID: values.employee?.RecordID || 0,
      TransferDate: values.empDate || "",
      FunctionsID: 0,
      DesignationID: 0,
      ProjectID: values.ProName?.RecordID || 0,
      ProjectName: values.ProName?.Name || "",
      AssignedBy: data.AssignedBy || 0,
      ApprovedBy: data.EMPID || 0,
      AssignedDate: data.AssignedDate || "",
      Source: data.Source || "",
      EmployeeStatus: data.EmployeeStatus || "",
      BlockedComments: values.blockedcomment ? values.blockedcomment : "",
      BlockedDate: values.blockedDate ? values.blockedDate : "",
      TaskPriority: values.TaskPriority ? values.TaskPriority : "Low",
      TargetDate: values.TargetDate ? values.TargetDate : data.TaskDate,
      TaskType: values.TaskType ? values.TaskType : "",
      ManagerComments: values.ManagerComments ? values.ManagerComments : "",
      ActivityID: values.Activities?.RecordID || 0,
      ActivityName: values.Activities?.Name || "",
      OperationstageID: values.OperationStage?.RecordID || 0,
      OperationstageName: values.OperationStage?.Name || "",
      MilestonesID: values.Milestone?.RecordID || 0,
      MilestonesName: values.Milestone?.Name || "",
      Lat: "",
      Lng: "",
      Outofboundary: ""
    };

    const response = await dispatch(postData({ accessID, action, idata }));

    if (response.payload.Status === "Y") {
      if (
        (values.status != data.Status && values.status == "C") ||
        mode == "B"
      ) {
        dispatch(
          requestMail({
            EmployeeID: EMPID,
            Type: "DT",
            RecordID: recID,
            encryptData: encryptDataUrlSafe(recID),
          })
        );
      }
      toast.success(response.payload.Msg);
      navigate(-1);
    } else {
      toast.error(response.payload.Msg);
    }
  };
  const ProductSaveFn = async (values, resetForm, del) => {
    setLoading(true);
    const isCheck = values.disable ? "Y" : "N";
    // let action = "update";

    // if (funMode === "A") action = "insert";
    // if (funMode === "E" && del) action = "harddelete";

    let action =
      funMode === "A" && !del
        ? "insert"
        : funMode === "E" && del
          ? "harddelete"
          : "update";
    const idata = {
      RecordID: funMode === "A" ? "-1" : productdata.recordID,
      CompanyID: compID,
      DailyTaskID: recID || "",
      CrmItemsID: values.productItems.RecordID || "",
      CrmItemGroupID: values.productGroupID || "",
      CrmItemCategoryID: values.productCategoryID || "",
      Uom: values.productUnit || "",
      Qty: values.productQty || "0",
      Rate: values.productRate || "0",
      Amount: values.productAmount || "0",
      Type: "Product",
      //Comments: values.productcomments.replace(/\s+/g, " ").trim() || ,
      Comments:
        values.productcomments &&
          values.productcomments.replace(/\s+/g, " ").trim() !== ""
          ? values.productcomments.replace(/\s+/g, " ").trim()
          : null,
      AdditionalBillable: values.productAdditionalBillable === true ? "Y" : "N",
    };

    const response = await dispatch(
      postData({ accessID: "TR322", action, idata })
    );

    if (response.payload.Status === "Y") {
      toast.success(response.payload.Msg);

      setLoading(false);

      dispatch(
        fetchExplorelitview(
          "TR322",
          "Product",
          `CompanyID='${compID}' AND DailyTaskID='${recID}' AND Type='Product'`,
          ""
        )
      );
      dispatch(getFetchData({ accessID, get: "get", recID }));
      selectCellRowData({ rowData: {}, mode: "A", field: "", type: "product" });
      resetForm();
    } else {
      toast.error(response.payload.Msg);
    }
  };

  const MaterialsSaveFn = async (values, resetForm, del) => {
    setLoading(true);
    const isCheck = values.disable ? "Y" : "N";
    // let action = "update";

    // if (funMode === "A") action = "insert";
    // if (funMode === "E" && del) action = "harddelete";

    let action =
      funMode === "A" && !del
        ? "insert"
        : funMode === "E" && del
          ? "harddelete"
          : "update";
    const idata = {
      RecordID: funMode === "A" ? "-1" : materialdata.recordID,
      CompanyID: compID,
      DailyTaskID: recID || "",
      CrmItemsID: values.materialItems.RecordID || "",
      CrmItemGroupID: values.materialGroupID || "",
      CrmItemCategoryID: values.materialCategoryID || "",
      Uom: values.materialUnit || "",
      Qty: values.materialQty || "0",
      Rate: values.materialRate || "0",
      Amount: values.materialAmount || "0",
      Type: "Material",
      //Comments: values.materialcomments.replace(/\s+/g, " ").trim(),
      Comments:
        values.materialcomments &&
          values.materialcomments.replace(/\s+/g, " ").trim() !== ""
          ? values.materialcomments.replace(/\s+/g, " ").trim()
          : null,
      AdditionalBillable:
        values.materialAdditionalBillable === true ? "Y" : "N",
    };

    const response = await dispatch(
      postData({ accessID: "TR322", action, idata })
    );

    if (response.payload.Status === "Y") {
      //toast.success(response.payload.Msg);
      setLoading(false);
      dispatch(
        fetchExplorelitview(
          "TR322",
          "Material",
          `CompanyID='${compID}' AND DailyTaskID='${recID}' AND Type='Material'`,
          ""
        )
      );
      dispatch(getFetchData({ accessID, get: "get", recID }))
      selectCellRowData({
        rowData: {},
        mode: "A",
        field: "",
        type: "material",
      });
      toast.success(response.payload.Msg);

      resetForm();
    } else {
      toast.error(response.payload.Msg);
    }
  };

  const ServiceSaveFn = async (values, resetForm, del) => {
    setLoading(true);
    const isCheck = values.disable ? "Y" : "N";
    // let action = "update";

    // if (funMode === "A") action = "insert";
    // if (funMode === "E" && del) action = "harddelete";

    let action =
      funMode === "A" && !del
        ? "insert"
        : funMode === "E" && del
          ? "harddelete"
          : "update";
    const idata = {
      RecordID: funMode === "A" ? "-1" : servicedata.recordID,
      CompanyID: compID,
      DailyTaskID: recID || "",
      CrmItemsID: values.serviceItems.RecordID || "",
      CrmItemGroupID: values.serviceGroupID || "",
      CrmItemCategoryID: values.serviceCategoryID || "",
      Uom: values.serviceUnit || "",
      Qty: values.serviceQty || "0",
      Rate: values.serviceRate || "0",
      Amount: values.serviceAmount || "0",
      Type: "Service",
      //Comments: values.servicecomments.replace(/\s+/g, " ").trim(),
      Comments:
        values.servicecomments &&
          values.servicecomments.replace(/\s+/g, " ").trim() !== ""
          ? values.servicecomments.replace(/\s+/g, " ").trim()
          : null,
      AdditionalBillable: values.serviceAdditionalBillable === true ? "Y" : "N",
    };

    const response = await dispatch(
      postData({ accessID: "TR322", action, idata })
    );

    if (response.payload.Status === "Y") {
      //toast.success(response.payload.Msg);
      setLoading(false);
      dispatch(
        fetchExplorelitview(
          "TR322",
          "Service",
          `CompanyID='${compID}' AND DailyTaskID='${recID}' AND Type='Service'`,
          ""
        )
      );
      dispatch(getFetchData({ accessID, get: "get", recID }))
      toast.success(response.payload.Msg);

      selectCellRowData({ rowData: {}, mode: "A", field: "", type: "service" });
      resetForm();
    } else {
      toast.error(response.payload.Msg);
    }
  };


  const MachinerySaveFn = async (values, resetForm, del) => {
    setLoading(true);

    let action =
      funMode === "A" && !del
        ? "insert"
        : funMode === "E" && del
          ? "harddelete"
          : "update";
    const idata = {
      RecordID: funMode === "A" ? "-1" : productdata.recordID,
      CompanyID: compID,
      DailyTaskID: recID || "",
      CrmItemsID: Number(values.machineryItems?.RecordID || 0),
      CrmItemGroupID: Number(values.machineryGroupID || 0),
      CrmItemCategoryID: Number(values.machineryCategoryID || 0),
      Uom: values.machineryUnit || "",
      Qty: Number(values.machineryQty ?? 1),
      Rate: Number(values.machineryRate || 0),
      Amount: Number(values.machineryAmount || 0),
      Type: "Machinery",
      Comments: values.machineryComments || "",
      AdditionalBillable: values.machineryAdditionalBillable === true ? "Y" : "N",
    };


    const response = await dispatch(
      postData({ accessID: "TR322", action, idata })
    );

    if (response.payload.Status === "Y") {
      toast.success(response.payload.Msg);

      setLoading(false);

      dispatch(
        fetchExplorelitview(
          "TR322",
          "Machinery",
          `CompanyID='${compID}' AND DailyTaskID='${recID}' AND Type='Machinery'`,
        )
      );
      dispatch(getFetchData({ accessID, get: "get", recID }));
      selectCellRowData({ rowData: {}, mode: "A", field: "", type: "machinery" });
      resetForm();
    } else {
      toast.error(response.payload.Msg);
    }
  };

  const UpdatesaveFn = async (values) => {
    let action = mode == "A" || mode == "U" ? "insert" : "update";
    const idata = {
      RecordID: "-1",
      DailyTaskID: params.id,
      Comments: values.updatecomments,
      SpendHours: values.SpentHours || 0,
      // ActualHourse: values.actualHours
    };
    const response = await dispatch(
      scrumUpdatepostData({ accessID, action, idata })
    );

    if (response.payload.Status === "Y") {
      toast.success(response.payload.Msg);
      dispatch(scrumUpdateget({ action: "get", recID }));
      // dispatch(postData({ accessID, action, idata }))

      navigate(-1);
    } else {
      toast.error(response.payload.Msg);
    }
  };

  const fnLogOut = (props) => {
    Swal.fire({
      // title: `Do you want ${props}?`,
      title: errorMsgData.Warningmsg[props],
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") {
          navigate("/");
        }
        if (props === "Close") {
          navigate(-1);
        }
      } else {
        return;
      }
    });
  };
  async function fileUpload(file, EMPID, action, id, purpose) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("empId", data.EmployeesID);
    formData.append("appId", data.RecordID);
    formData.append("type", "DT");
    formData.append("source", "Self");
    formData.append("action", action);
    formData.append("id", id);
    formData.append("purpose", purpose ? purpose : "");
    const respose = await dispatch(attachmentPost({ data: formData }));

    if (respose.payload.success) {
      toast.success(respose.payload.message);
      //setShowtable(true);
      var url = store.getState().globalurl.empGetAttachmentUrl;
      axios
        .get(url, {
          params: {
            empId: data.EmployeesID,
            appId: data.RecordID,
          },
        })
        .then((response) => {
          setFiles(response.data);
        })
        .catch((err) => {
          setError("Failed to fetch attachments.");
          console.error(err);
        })
        .finally(() => setLoading(false));
    } else {
      toast.success(respose.payload.message);
    }
  }

  function Custombar() {
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Typography>List Of Inprogress</Typography>
          <Typography variant="h5">{`(${rowCount})`}</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <GridToolbarQuickFilter />
        </Box>
      </GridToolbarContainer>
    );
  }
  function Employee() {
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          {/* <Typography>
            {show == "2" ? "List of Functions" : "List of Designation"}||{show=="6" && "List of Documents"}
            
          </Typography> */}
          <Typography>
            {show == "1"
              ? "List of Products"
              : show == "2"
                ? "List of Materials"
                : show == "3"
                  ? "List of Services"
                  : ""}
          </Typography>
          <Typography variant="h5">{`(${rowCount})`}</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <GridToolbarQuickFilter />
          <Tooltip title="ADD">
            <IconButton type="reset">
              <AddOutlinedIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </GridToolbarContainer>
    );
  }
  function ProductReset() {
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          {/* <Typography>
            {show == "2" ? "List of Functions" : "List of Designation"}||{show=="6" && "List of Documents"}
            
          </Typography> */}
          <Typography>List of Products</Typography>
          <Typography variant="h5">{`(${rowCount})`}</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <GridToolbarQuickFilter />
          <Tooltip title="ADD">
            <IconButton type="reset">
              <AddOutlinedIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </GridToolbarContainer>
    );
  }
  function MaterialReset() {
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          {/* <Typography>
            {show == "2" ? "List of Functions" : "List of Designation"}||{show=="6" && "List of Documents"}
            
          </Typography> */}
          <Typography>List of Material</Typography>
          <Typography variant="h5">{`(${rowCount})`}</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <GridToolbarQuickFilter />
          <Tooltip title="ADD">
            <IconButton type="reset">
              <AddOutlinedIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </GridToolbarContainer>
    );
  }
  function ServiceReset() {
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          {/* <Typography>
            {show == "2" ? "List of Functions" : "List of Designation"}||{show=="6" && "List of Documents"}
            
          </Typography> */}
          <Typography>List of Services</Typography>
          <Typography variant="h5">{`(${rowCount})`}</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <GridToolbarQuickFilter />
          <Tooltip title="ADD">
            <IconButton type="reset">
              <AddOutlinedIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </GridToolbarContainer>
    );
  }
  function MachineryReset() {
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Typography>List of Machinery</Typography>
          <Typography variant="h5">{`(${rowCount})`}</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <GridToolbarQuickFilter />
          <Tooltip title="ADD">
            <IconButton type="reset">
              <AddOutlinedIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </GridToolbarContainer>
    );
  }
  // 1. Define statusMap selector
  const getStatusMap = (taskSource, mode) => {
    if (taskSource === "Manager" && mode === "P") {
      return {
        // 1: "Created",
        // 2: "Picked",
        // 3: "Completed",
        // 4: "Approved",
        // 5: "Blocked",
        1: "Created",
        2: "Picked",
        3: "Inprogress",
        4: "Completed",
        5: "Approved",
        6: "Blocked",
      };
    } else if (taskSource === "Manager" && mode === "B") {
      return {
        1: "Created",
        2: "Picked",
        3: "Blocked",
      };
    } else if (taskSource === "Manager" && mode === "A") {
      return {
        1: "Picked",
        2: "Completed",
        3: "Approved",
      };
    } else {
      // Default scenario
      return {
        // 1: "Created",
        // 2: "Completed",
        // 3: "Approved",
        // 4: "Rejected",
        // 5: "Blocked",
        1: "Created",
        2: "Inprogress",
        3: "Completed",
        4: "Approved",
        5: "Rejected",
        6: "Blocked",
      };
    }
  };


  const InitialValue = {
    code: data.Code,
    name: data.Name,
    sortorder: data.SortOrder,
    disable: data.Disable === "Y" ? true : false,
  };

  // 2. Get the task source and mode (pass your actual values here)
  const taskSource = data.TaskSource;
  const statusMap = getStatusMap(taskSource, mode);
  const chartOptions = {
    chart: {
      id: "task-status-tracker",
      type: "line",
      toolbar: { show: false },
    },
    title: {
      text: "Task Status Timeline",
      align: "center",
    },
    xaxis: {
      type: "date",
      title: { text: "Date" },
    },
    yaxis: {
      min: 0,
      max: 6,
      tickAmount: 6,
      title: { text: "Status" },
      labels: {
        formatter: (val) => statusMap[val] || "",
        minWidth: 120,
      },
    },
    markers: {
      size: 6,
    },
    stroke: {
      curve: "smooth",
    },
  };

  const columns = [
    {
      field: "SLNO",
      headerName: "SL#",
      width: 50,
      headerAlign: "center",
    },
    {
      field: "actions",
      headerName: "Action",
      width: 80,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Tooltip title="Edit">
          <IconButton
            color="primary"
            size="small"
            onClick={() => handleEditClick(params.row)}
          >
            <EditIcon />
          </IconButton>
        </Tooltip>
      ),
    },
    {
      field: "DailyTaskUpdateRecordID",
      headerName: "RecordID",
      width: 200,
      headerAlign: "center",
      hide: true,
    },
    {
      field: "DailyTaskUpdateCreatedDate",
      headerName: "Date",
      width: 150,
      headerAlign: "center",
      hide: false,
    },
    {
      field: "DailyTaskUpdateCreatedTime",
      headerName: "Time",
      width: 100,
      headerAlign: "center",
      hide: false,
    },
    {
      field: "SpendHours",
      headerName: "Spend Hours",
      width: 100,
      headerAlign: "center",
      align: "right",
      hide: false,
    },
    {
      field: "DailyTaskUpdateComments",
      headerName: "Comments",
      width: 800,
      headerAlign: "center",
    },
    // {
    //   field: "Approved Date",
    //   headerName: "Approved Date",
    //   width: 200,
    //   headerAlign: "center"
    // },
  ];
  let VISIBLE_FIELDS = []; // <-- default always array

  if (show == "1") {
    VISIBLE_FIELDS = [
      "SLNO",
      "CrmItemsName",
      "Rate",
      "Qty",
      "Amount",
      "action",
    ];
  } else if (show == "2") {
    VISIBLE_FIELDS = [
      "SLNO",
      "CrmItemsName",
      "Rate",
      "Qty",
      "Amount",
      "action",
    ];
  } else if (show == "3") {
    VISIBLE_FIELDS = [
      "SLNO",
      "CrmItemsName",
      "Rate",
      "Qty",
      "Amount",
      "action",
    ];
  } else if (show == "4") {
    VISIBLE_FIELDS = [
      "SLNO",
      "CrmItemsName",
      "Rate",
      "Qty",
      "Amount",
      "action",
    ];
  }

  const newcolumn = React.useMemo(
    () =>
      explorelistViewcolumn.filter((column) =>
        VISIBLE_FIELDS.includes(column.field)
      ),
    [explorelistViewcolumn]
  );
  // const columns2 = React.useMemo(() => {
  //   // Convert visible fields to lowercase
  //   const safeFields = Array.isArray(VISIBLE_FIELDS)
  //     ? VISIBLE_FIELDS.map((f) => f.toLowerCase())
  //     : [];

  //   // Convert column.field to lowercase before comparison
  //   let visibleColumns = explorelistViewcolumn.filter((column) =>
  //     safeFields.includes(column.field.toLowerCase())
  //   );

  //   // Add SLNO manually
  //   if (safeFields.includes("slno")) {
  //     const slnoColumn = {
  //       field: "SLNO",
  //       headerName: "SL#",
  //       width: 50,
  //       sortable: false,
  //       filterable: false,
  //     };

  //     visibleColumns = [slnoColumn, ...visibleColumns];
  //   }

  //   return visibleColumns;
  // }, [explorelistViewcolumn, VISIBLE_FIELDS]);
  // console.log(explorelistViewData);
  // console.log(columns2);

  const columns2 = React.useMemo(() => {
    const safeFields = Array.isArray(VISIBLE_FIELDS) ? VISIBLE_FIELDS : [];

    let visibleColumns = explorelistViewcolumn.filter((column) =>
      safeFields.includes(column.field)
    );

    if (safeFields.includes("slno")) {
      const slnoColumn = {
        field: "slno",
        headerName: "SL#",
        width: 50,
        sortable: false,
        filterable: false,
      };

      visibleColumns = [slnoColumn, ...visibleColumns];
    }

    return visibleColumns;
  }, [explorelistViewcolumn, VISIBLE_FIELDS]);

  const [isEditing, setIsEditing] = useState(false);

  // const handleEditClick = (row, setFieldValue) => {
  //   setFunMode("E"); // Enable Edit mode

  //   // Fill Formik fields
  //   setFieldValue("items", {
  //     RecordID: row.CrmItemsID,
  //     Code: row.CrmItemsCode,
  //     Name: row.CrmItemsName,
  //   });

  //   setFieldValue("itemCategoryID", row.CrmItemCategoryID || "");
  //   setFieldValue("itemGroupID", row.CrmItemGroupID || "");
  //   setFieldValue("unit", row.Uom || "");
  //   setFieldValue("productRate", row.Rate || "");
  //   setFieldValue("productQty", row.Qty || "");
  //   setFieldValue("productAmount", row.Amount || "");
  //   setFieldValue("productcomments", row.Comments || "");

  //   console.log("Loaded row into form:", row);
  // };
  const handleEditClick = (row, setFieldValue) => {
    //setIsEditing(true); // show the form panel
    if (row) {
      setFieldValue("CreatedDate", row.DailyTaskUpdateCreatedDate || "");
      setFieldValue("CreatedTime", row.DailyTaskUpdateCreatedTime || "");
      setFieldValue("Comments", row.DailyTaskUpdateComments || "");
      setFieldValue("Hours", row.SpendHours || "");
    }
  };
  console.log("🚀 ~ EditDailytask ~ state.DailyTaskDate:", state.DailyTaskDate);
  return (
    <React.Fragment>
      {getLoading ? <LinearProgress /> : false}
      {exploreLoading ? <LinearProgress /> : false}
      {isLoading ? <LinearProgress /> : false}
      <Paper
        elevation={3}
        sx={{ margin: "0px 10px", background: "#F2F0F0", height: "50px" }}
      >
        <Box display="flex" justifyContent="space-between">
          <Box display="flex" borderRadius="3px" alignItems="center">
            {broken && !rtl && (
              <IconButton onClick={() => toggleSidebar()}>
                <MenuOutlinedIcon />
              </IconButton>
            )}
            <Box
              display={isNonMobile ? "flex" : "none"}
              borderRadius="3px"
              alignItems="center"
            >
              <Breadcrumbs
                maxItems={3}
                aria-label="breadcrumb"
                separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
              >
                <Typography
                  variant="h5"
                  color="#0000D1"
                  sx={{
                    cursor: "default",
                    marginLeft: "10px",
                  }}
                  onClick={() => navigate("/Apps/TR132/Scrum%20Task")}
                >
                  {(mode === "E" ||
                    mode === "V" ||
                    mode === "U" ||
                    mode == "IM") &&
                    mode != "C" &&
                    mode != "B"
                    ? is003Subscription
                      ? "Daily Activities" : `Scrum Task(${formattedDate})`
                    : ""}



                  {(mode === "C" ||
                    mode === "B" ||
                    mode === "UB" ||
                    // mode === "U" ||
                    mode === "P") &&
                    mode !== "E" ? (
                    <Typography
                      variant="h5"
                      color="#0000D1"
                      sx={{ cursor: "default" }}
                    >
                      {is003Subscription ? "Daily Activities" : `Scrum Task (${
                        //params.Date || data.CheckInDate || data.TaskDate
                        formattedDate
                        })`}
                      <Typography
                        variant="h5"
                        component="span"
                        sx={{
                          color:
                            mode == "B"
                              ? "warning.main"
                              : mode == "UB"
                                ? "warning.main"
                                : mode == "P"
                                  ? "warning.primary"
                                  : mode === "C"
                                    ? "success.main"
                                    : data.Status === "I"
                                      ? "info.main"
                                      : "text.primary",
                          fontWeight: 600,
                          marginLeft: 1,
                        }}
                      >
                        {mode == "B"
                          ? "-- Block"
                          : mode == "UB"
                            ? "-- UnBlock"
                            : mode == "P"
                              ? "-- Pick Now"
                              : mode === "C"
                                ? "-- Completed"
                                : data.Status === "I"
                                  ? "-- Inprogress"
                                  : ""}
                      </Typography>
                    </Typography>
                  ) : null}

                  {/* {mode === "A" ? "Scrum Task(New) " : ""} */}
                  {mode === "A" ? (is003Subscription ? "Daily Activities" : "Scrum Task(New) ") : ""}
                </Typography>
                {show == "1" ? (
                  <Typography
                    variant="h5"
                    color="#0000D1"
                    sx={{ cursor: "default" }}
                  >
                    Product
                  </Typography>
                ) : (
                  false
                )}
                {show == "2" ? (
                  <Typography
                    variant="h5"
                    color="#0000D1"
                    sx={{ cursor: "default" }}
                  >
                    Material
                  </Typography>
                ) : (
                  false
                )}
                {show == "3" ? (
                  <Typography
                    variant="h5"
                    color="#0000D1"
                    sx={{ cursor: "default" }}
                  >
                    Services
                  </Typography>
                ) : (
                  false
                )}
              </Breadcrumbs>
            </Box>
          </Box>
          <Box display="flex">
            {mode !== "A" ? (
              <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                <InputLabel id="demo-select-small">Explore</InputLabel>
                <Select
                  labelId="demo-select-small"
                  id="demo-select-small"
                  value={show}
                  label="Explore"
                  onChange={screenChange}
                >
                  <MenuItem value={0}>{is003Subscription ? "Daily Activities" : "Scrum Task"}</MenuItem>
                  <MenuItem value={1}>Product</MenuItem>
                  <MenuItem value={2}>Material</MenuItem>
                  <MenuItem value={3}>Services</MenuItem>
                  <MenuItem value={4}>Machinery</MenuItem>
                  {/* <MenuItem value={8}>Change Password</MenuItem> */}
                </Select>
              </FormControl>
            ) : (
              false
            )}
            <Tooltip title="Close">
              <IconButton onClick={() => fnLogOut("Close")} color="error">
                <ResetTvIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Logout">
              <IconButton color="error" onClick={() => fnLogOut("Logout")}>
                <LogoutOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Paper>
      {show == "0" && !getLoading ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          {mode === "IM" && (
            <Box
              display="flex"
              padding={1}
              justifyContent="flex-end"
              mt="2px"
              gridColumn="span 4"
              gap={2}
              marginBottom={-5}
            >
              <IconButton
                onClick={() => setShowImage((prev) => !prev)}
                sx={{ padding: "12px" }}
              >
                <ArrowDownwardIcon
                  sx={{ color: "blue", marginBottom: "8px" }}
                />
              </IconButton>
            </Box>
          )}

          <Formik
            enableReinitialize={true}
            initialValues={dailyTaskInitialValue}
            onSubmit={(values, setSubmitting) => {
              setTimeout(() => {
                if (mode == "U") {
                  UpdatesaveFn(values);
                } else {
                  DTSaveFn(values);
                }
              }, 100);
            }}
            validationSchema={validationSchema}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                {data.Status == "T" ? (
                  <Stack
                    sx={{ mb: 4 }}
                    spacing={{ xs: 1, sm: 2 }}
                    direction="row"
                    useFlexGap
                    flexWrap="wrap"
                  >
                    <Chip label={EmpName} variant="outlined" />
                    <ArrowForwardIcon />
                    <Chip label={data.EmployeeName} variant="outlined" />
                  </Stack>
                ) : (
                  false
                )}
                <Box
                  display="grid"
                  gridTemplateColumns="repeat(4 , minMax(0,1fr))"
                  gap={formGap}
                  padding={1}
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 4",
                    },
                  }}
                >
                  <TextField
                    disabled={
                      data.TaskSource === "Manager" ||
                      data.TaskSource === "Sprint" ||
                      data.Status === "Approved" ||
                      mode === "T" ||
                      mode === "C" ||
                      mode === "V" ||
                      mode === "U"
                    }
                    name="date"
                    type="date"
                    id="date"
                    label={
                      <>
                        Date
                        <span style={{ color: "red", fontSize: "20px" }}>
                          {" "}
                          *{" "}
                        </span>
                      </>
                    }
                    variant="standard"
                    focused
                    format="MM-DD-YYYY"
                    value={values.date}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.date && !!errors.date}
                    helperText={touched.date && errors.date}
                    sx={{ gridColumn: "span 2", background: "" }}
                    InputLabelProps={{ shrink: true }}
                    inputProps={{
                      //min: curdate,
                      max: curdate,
                    }}
                  />

                  <TextField
                    disabled={
                      data.TaskSource === "Manager" ||
                      data.TaskSource === "Sprint" ||
                      data.Status === "Approved" ||
                      mode === "T" ||
                      mode === "C" ||
                      mode === "V" ||
                      mode === "U"
                    }
                    name="description"
                    type="text"
                    id="description"
                    label={
                      <>
                        Title
                        <span style={{ color: "red", fontSize: "20px" }}>
                          {" "}
                          *{" "}
                        </span>
                      </>
                    }
                    variant="standard"
                    focused
                    value={values.description}
                    error={!!touched.description && !!errors.description}
                    helperText={touched.description && errors.description}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    sx={{ gridColumn: "span 2" }}
                    inputProps={{ maxLength: 50 }}
                  // required
                  />
                  {!showImage ? (
                    <React.Fragment>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          gridColumn: "span 2",
                        }}
                      >
                        <CheckinAutocomplete
                          name="ProName"
                          label={
                            <>
                              Project
                              <span style={{ color: "red", fontSize: "20px" }}>
                                {" "}
                                *{" "}
                              </span>
                            </>
                          }
                          id="ProName"
                          value={values.ProName}
                          onChange={(newValue) => {
                            setFieldValue("ProName", newValue);
                          }}
                          error={!!touched.ProName && !!errors.ProName}
                          helperText={touched.ProName && errors.ProName}
                          url={`${listViewurl}?data={"Query":{"AccessID":"2114","ScreenName":"Project","Filter":"parentID=${compID} AND EmployeeID=${EMPID}","Any":""}}`}
                          disabled={
                            data.TaskSource === "Manager" ||
                            data.TaskSource === "Sprint" ||
                            data.Status === "Approved" ||
                            mode === "T" ||
                            mode === "C" ||
                            mode === "V" ||
                            mode === "U"
                          }
                        // inputProps={
                        //   data.TaskSource === "Self"
                        //     ? { readOnly: true }
                        //     : { readOnly: false }
                        // }
                        />
                        {!is003Subscription && (
                          <Tooltip title={showMore ? "Close" : "Open"}>
                            <IconButton
                              onClick={() => setShowMore((prev) => !prev)}
                            >
                              {showMore ? <MoreHorizIcon /> : <MoreVertIcon />}
                            </IconButton>
                          </Tooltip>
                        )}
                      </Box>
                      {showMore && (
                        <>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              gridColumn: "span 2",
                            }}
                          >
                            <CheckinAutocomplete
                              // sx={{ gridColumn: "span 2" }}
                              name="Milestone"
                              label="Milestone"
                              variant="outlined"
                              id="Milestone"
                              value={values.Milestone}
                              getOptionLabel={(option) => option?.Name || ""}
                              onChange={(newValue) => {
                                setFieldValue("Milestone", newValue);
                                // setSelectedMiles(newValue)
                              }}
                              // url={`${listViewurl}?data={"Query":{"AccessID":"2105","ScreenName":"Milestone","Filter":"parentID='${selectedPro ? selectedPro.RecordID : 0}'","Any":""}}`}
                              url={`${listViewurl}?data={"Query":{"AccessID":"2105","ScreenName":"Milestone","Filter":"parentID IN(${values.ProName?.RecordID}) AND CompanyID='${compID}'","Any":""}}`}
                              disabled={
                                data.TaskSource === "Manager" ||
                                data.TaskSource === "Sprint" ||
                                data.Status === "Approved" ||
                                mode === "T" ||
                                mode === "C" ||
                                mode === "V" ||
                                mode === "U"
                              }
                            />
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              gridColumn: "span 2",
                            }}
                          >
                            <CheckinAutocomplete
                              // sx={{ marginTop: "7px" }}
                              // sx={{ gridColumn: "span 2" }}
                              name="OperationStage"
                              label="Operation Stage"
                              variant="outlined"
                              id="OperationStage"
                              value={values.OperationStage}
                              onChange={(newValue) => {
                                setFieldValue("OperationStage", newValue);
                                // setSelectedOS(newValue)
                              }}
                              url={`${listViewurl}?data={"Query":{"AccessID":"2104","ScreenName":"Operation Stage","Filter":"parentID IN(${values.Milestone?.RecordID})","Any":""}}`}
                              disabled={
                                data.TaskSource === "Manager" ||
                                data.TaskSource === "Sprint" ||
                                data.Status === "Approved" ||
                                mode === "T" ||
                                mode === "C" ||
                                mode === "V" ||
                                mode === "U"
                              }
                            />
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              gridColumn: "span 2",
                            }}
                          >
                            <CheckinAutocomplete
                              // sx={{ marginTop: "7px" }}
                              // sx={{ gridColumn: "span 2" }}
                              name="Activities"
                              label="Activities"
                              variant="outlined"
                              id="Activities"
                              value={values.Activities}
                              onChange={(newValue) => {
                                setFieldValue("Activities", newValue);
                                // setSelectedAct(newValue)
                              }}
                              url={`${listViewurl}?data={"Query":{"AccessID":"2103","ScreenName":"Activities","Filter":"parentID IN(${values.OperationStage?.RecordID || 0
                                })","Any":""}}`}
                              disabled={
                                data.TaskSource === "Manager" ||
                                data.TaskSource === "Sprint" ||
                                data.Status === "Approved" ||
                                mode === "T" ||
                                mode === "C" ||
                                mode === "V" ||
                                mode === "U"
                              }
                            />
                          </Box>
                        </>
                      )}
                      <TextField
                        disabled={
                          data.TaskSource === "Manager" ||
                          data.TaskSource === "Sprint" ||
                          data.Status === "Approved" ||
                          mode === "T" ||
                          mode === "C" ||
                          mode === "V" ||
                          mode === "U"
                        }
                        name="estimatedHours"
                        type="number"
                        id="estimatedHours"
                        label={
                          <>
                            Estimated Hours
                            <span style={{ color: "red", fontSize: "20px" }}>
                              {" "}
                              *{" "}
                            </span>
                          </>
                        }
                        // required
                        variant="standard"
                        fullWidth
                        focused
                        value={values.estimatedHours}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={
                          !!touched.estimatedHours && !!errors.estimatedHours
                        }
                        helperText={
                          touched.estimatedHours && errors.estimatedHours
                        }
                        sx={{ gridColumn: "span 2" }}
                        InputProps={{
                          sx: { textAlign: "right" },
                          inputProps: {
                            style: { textAlign: "right" },
                          },
                        }}
                      />
                      <TextField
                        disabled={
                          data.Status === "Approved" ||
                          mode === "V" ||
                          mode === "U"
                        }
                        name="actualHours"
                        type="number"
                        id="actualHours"
                        // label={
                        //   <>
                        //     Actual Hours
                        //     <span style={{ color: "red", fontSize: "20px" }}>
                        //       {" "}
                        //       *{" "}
                        //     </span>
                        //   </>
                        // }
                        label="Actual Hours"
                        // required
                        variant="standard"
                        fullWidth
                        focused
                        value={values.actualHours}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={!!touched.actualHours && !!errors.actualHours}
                        helperText={touched.actualHours && errors.actualHours}
                        sx={{ gridColumn: "span 2" }}
                        InputProps={{
                          sx: { textAlign: "right" },
                          inputProps: {
                            style: { textAlign: "right" },
                          },
                        }}
                      />

                      <FormControl
                        focused
                        variant="standard"
                        sx={{ gridColumn: "span 2" }}
                        disabled={
                          !isReadOnlyAssigned &&
                          (data.Status === "Approved" ||
                            mode === "C" ||
                            mode === "A" ||
                            mode == "B" ||
                            mode === "UB" ||
                            mode === "V" ||
                            mode === "U")
                        }
                      >
                        <InputLabel id="status">Status</InputLabel>
                        <Select
                          readOnly={isReadOnlyAssigned}
                          disabled={
                            data.Status === "Approved" ||
                            mode === "C" ||
                            mode == "B" ||
                            mode == "A" ||
                            mode == "UB" ||
                            mode === "V" ||
                            mode === "U"
                          }
                          labelId="demo-simple-select-filled-label"
                          id="status"
                          name="status"
                          value={values.status}
                          onBlur={handleBlur}
                          onChange={handleChange}
                        >
                          <MenuItem value="I">Inprogress</MenuItem>
                          <MenuItem value="C">Completed</MenuItem>
                          {isManager === 1 && (
                            <MenuItem value="B">Blocked</MenuItem>
                          )}
                          {(mode == "B" || mode == "V") && (
                            <MenuItem value="B">Blocked</MenuItem>
                          )}
                          {isManager === 1 ||
                            (mode == "V" && (
                              <MenuItem value="AP">Approved</MenuItem>
                            ))}
                          {values.status == "RJ" && (
                            <MenuItem value="RJ">Rejected</MenuItem>
                          )}
                        </Select>
                      </FormControl>

                      <TextField
                        fullWidth
                        disabled={
                          data.TaskSource === "Manager" ||
                          data.TaskSource === "Sprint" ||
                          data.Status === "Approved" ||
                          mode === "T" ||
                          mode === "C" ||
                          mode === "V" ||
                          mode === "U"
                        }
                        name="TargetDate"
                        type="date"
                        id="TargetDate"
                        label={
                          <>
                            Target Date
                            <span style={{ color: "red", fontSize: "20px" }}>
                              {" "}
                              *{" "}
                            </span>
                          </>
                        }
                        variant="standard"
                        focused
                        format="MM-DD-YYYY"
                        InputLabelProps={{ shrink: true }}
                        value={values.TargetDate}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.TargetDate && !!errors.TargetDate}
                        helperText={touched.TargetDate && errors.TargetDate}
                        sx={{ gridColumn: "span 2", background: "" }}
                      // required
                      />
                      {/* <FormControl
                      // required
                      focused
                      variant="standard"
                      sx={{ gridColumn: "span 2" }}
                      
                    >
                      <InputLabel id="status2">{
                        <>
                          Task Type<span style={{ color: "red", fontSize: "20px" }}> * </span>
                        </>
                      }</InputLabel> */}
                      <TextField
                        disabled={
                          data.TaskSource === "Manager" ||
                          data.TaskSource === "Sprint" ||
                          data.Status === "Approved" ||
                          mode === "T" ||
                          mode === "C" ||
                          mode === "V" ||
                          mode === "U"
                        }
                        sx={{ gridColumn: "span 2" }}
                        labelId="status2"
                        id="TaskType"
                        name="TaskType"
                        type="text"
                        focused
                        fullWidth
                        variant="standard"
                        label={
                          <>
                            Task Type
                            <span style={{ color: "red", fontSize: "20px" }}>
                              {" "}
                              *{" "}
                            </span>
                          </>
                        }
                        value={values.TaskType}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.TaskType && !!errors.TaskType}
                        helperText={touched.TaskType && errors.TaskType}
                        select
                      >
                        <MenuItem value="Normal">Normal</MenuItem>
                        <MenuItem value="Learning&development">
                          Learning & development
                        </MenuItem>
                        <MenuItem value="Research&development">
                          Research & development
                        </MenuItem>
                        <MenuItem value="Up-skill">Up-skill</MenuItem>
                        <MenuItem value="Bug">Bug</MenuItem>
                        <MenuItem value="Improvements">Improvements</MenuItem>
                        <MenuItem value="Minutes of Meeting">
                          Minutes of Meeting
                        </MenuItem>
                        <MenuItem value="Script">Script</MenuItem>
                        <MenuItem value="Documentation">Documentation</MenuItem>
                      </TextField>

                      {/* </FormControl> */}
                      {values.status === "T" || mode === "T" ? (
                        <Employeeautocomplete
                          disabled={
                            data.TaskSource === "Manager" ||
                            data.TaskSource === "Sprint" ||
                            mode === "C" ||
                            mode === "V" ||
                            mode === "U"
                          }
                          sx={{ gridColumn: "span 2" }}
                          name="employee"
                          label="Employee"
                          id="employee"
                          value={values.employee}
                          onChange={(newValue) => {
                            setFieldValue("employee", newValue);
                          }}
                          error={!!touched.employee && !!errors.employee}
                          helperText={touched.employee && errors.employee}
                          url={`${listViewurl}?data={"Query":{"AccessID":"2024","ScreenName":"Employee","Filter":"CompanyID=${compID}","Any":"","CompId":""}}`}
                        />
                      ) : (
                        false
                      )}
                      {values.status == "T" || mode === "T" ? (
                        <TextField
                          disabled={
                            data.TaskSource === "Manager" ||
                            data.TaskSource === "Sprint" ||
                            mode === "V"
                          }
                          required
                          name="empDate"
                          type="date"
                          id="empDate"
                          // label={mode === "C" ? "Completed Date" : "Transfer Date"}
                          label="Transfer Date"
                          inputFormat="YYYY-MM-DD"
                          variant="standard"
                          focused
                          value={values.empDate}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={!!touched.empDate && !!errors.empDate}
                          helperText={touched.empDate && errors.empDate}
                          sx={{ gridColumn: "span 2" }}
                          InputLabelProps={{
                            shrink: true,
                            sx: mode === "V" ? { marginBottom: "12px" } : {},
                          }}
                        />
                      ) : (
                        false
                      )}
                    </React.Fragment>
                  ) : (
                    false
                  )}
                </Box>
                {!showImage ? (
                  <React.Fragment>
                    <Box padding={1}>
                      <Grid container spacing={2}>
                        {/* Left Side: Comment */}
                        <Grid item xs={12} md={6}>
                          <TextField
                            variant="standard"
                            fullWidth
                            type="text"
                            focused
                            //sx={{ gridColumn: "span 2" }}
                            label={
                              <>
                                Task Priority
                                <span
                                  style={{ color: "red", fontSize: "20px" }}
                                >
                                  {" "}
                                  *{" "}
                                </span>
                              </>
                            }
                            disabled={
                              data.TaskSource === "Manager" ||
                              data.TaskSource === "Sprint" ||
                              data.Status === "Approved" ||
                              mode === "T" ||
                              mode === "C" ||
                              mode === "V" ||
                              mode === "U"
                            }
                            labelId="status2"
                            id="TaskPriority"
                            name="TaskPriority"
                            value={values.TaskPriority}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            error={
                              !!touched.TaskPriority && !!errors.TaskPriority
                            }
                            helperText={
                              touched.TaskPriority && errors.TaskPriority
                            }
                            select
                          >
                            <MenuItem value="Low">Low</MenuItem>
                            <MenuItem value="Medium">Medium</MenuItem>
                            <MenuItem value="High">High</MenuItem>
                          </TextField>
                        </Grid>
                        {mode === "U" && (
                          <Grid item xs={12} md={6}>
                            <Stack spacing={2}>
                              <TextField
                                disabled={
                                  data.Status === "Approved" || mode === "V"
                                }
                                name="SpentHours"
                                type="number"
                                id="SpentHours"
                                label="Spend Hours"
                                variant="standard"
                                fullWidth
                                focused
                                value={values.SpentHours}
                                onChange={(e) => {
                                  const newSpent = Number(e.target.value || 0);

                                  // change in value
                                  const diff = newSpent - oldSpent;

                                  // update spent hours
                                  handleChange(e);

                                  // update actual hours correctly
                                  setFieldValue(
                                    "actualHours",
                                    Number(values.actualHours || 0) + diff
                                  );

                                  // save newSpent as oldSpent for next change
                                  setOldSpent(newSpent);
                                }}
                                onBlur={handleBlur}
                                error={
                                  !!touched.SpentHours && !!errors.SpentHours
                                }
                                helperText={
                                  touched.SpentHours && errors.SpentHours
                                }
                                InputProps={{
                                  sx: { textAlign: "right" },
                                  inputProps: {
                                    style: { textAlign: "right" },
                                  },
                                }}
                              />
                            </Stack>
                          </Grid>
                        )}
                        <Grid item xs={12} md={6}>
                          <Stack spacing={2}>
                            <TextField
                              disabled={
                                data.TaskSource === "Manager" ||
                                data.TaskSource === "Sprint" ||
                                data.Status === "Approved" ||
                                mode === "T" ||
                                mode === "C" ||
                                mode === "V" ||
                                mode === "U"
                              }
                              name="Comment"
                              type="text"
                              id="Comment"
                              label={
                                <>
                                  Comment
                                  <span
                                    style={{ color: "red", fontSize: "20px" }}
                                  >
                                    {" "}
                                    *{" "}
                                  </span>
                                </>
                              }
                              multiline
                              rows={4}
                              variant="outlined"
                              fullWidth
                              focused
                              // required
                              value={values.Comment}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              error={!!touched.Comment && !!errors.Comment}
                              helperText={touched.Comment && errors.Comment}
                              sx={{ gridColumn: "span 2" }}
                            />
                          </Stack>
                        </Grid>
                        {mode === "U" && (
                          <Grid item xs={12} md={6}>
                            <Stack spacing={2}>
                              <TextField
                                name="updatecomments"
                                id="updatecomments"
                                label="Update Comments"
                                multiline
                                rows={4}
                                variant="outlined"
                                fullWidth
                                focused
                                required
                                value={values.updatecomments}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={
                                  !!touched.updatecomments &&
                                  !!errors.updatecomments
                                }
                                helperText={
                                  touched.updatecomments &&
                                  errors.updatecomments
                                }
                              />
                            </Stack>
                          </Grid>
                        )}

                        {/* Right Side: Transfer To Employee + Transfer To Date */}
                        {/* <Grid item xs={12} md={12}>
                          <Stack spacing={2}>
                            {values.status === "RJ" ? (
                              <TextField
                                name="ManagerComments"
                                type="text"
                                id="ManagerComments"
                                label="Manager Comments"
                                multiline
                                rows={4}
                                variant="outlined"
                                fullWidth
                                focused
                                required
                                value={values.ManagerComments}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                sx={{ gridColumn: "span 2" }}
                              />
                            ) : (
                              false
                            )}
                            {values.status == "B" ? (
                              <TextField
                                disabled={mode === "V"}
                                required
                                name="blockedDate"
                                type="date"
                                id="blockedDate"
                                label="Blocked Date"
                                inputFormat="YYYY-MM-DD"
                                variant="standard"
                                focused
                                value={values.blockedDate}
                                onBlur={handleBlur}
                                onChange={handleChange}
                                error={
                                  !!touched.blockedDate && !!errors.blockedDate
                                }
                                helperText={
                                  touched.blockedDate && errors.blockedDate
                                }
                                sx={{
                                  gridColumn: "span 2",
                                  "& .MuiInputLabel-root":
                                    mode === "V"
                                      ? {
                                          transform:
                                            "translate(0, 1.5px) scale(0.75)",
                                          color: "#888", // Optional: match label color
                                        }
                                      : {},
                                  "& .MuiInput-root:before":
                                    mode === "V"
                                      ? {
                                          borderBottom:
                                            "1px dotted rgba(0,0,0,0.42)", // mimic disabled underline
                                        }
                                      : {},
                                }}
                              />
                            ) : (
                              false
                            )}
                            {values.status === "B" ? (
                              <TextField
                                disabled={mode === "V"}
                                name="blockedcomment"
                                type="text"
                                id="blockedcomment"
                                label="Blocked Comments"
                                // multiline
                                // rows={6}
                                variant="standard"
                                fullWidth
                                focused
                                required
                                value={values.blockedcomment}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={
                                  !!touched.blockedcomment &&
                                  !!errors.blockedcomment
                                }
                                helperText={
                                  touched.blockedcomment &&
                                  errors.blockedcomment
                                }
                                sx={{ gridColumn: "span 2" }}
                              />
                            ) : (
                              false
                            )}
                            {mode == "U" ? (
                              <>
                              <TextField
                                name="updatecomments"
                                type="text"
                                id="updatecomments"
                                label="Update Comments"
                                multiline
                                rows={4}
                                variant="outlined"
                                fullWidth
                                focused
                                required
                                value={values.updatecomments}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={
                                  !!touched.updatecomments &&
                                  !!errors.updatecomments
                                }
                                helperText={
                                  touched.updatecomments &&
                                  errors.updatecomments
                                }
                                sx={{ gridColumn: "span 2" }}
                              />
                              
                              </>
                            ) : null}
                           
                           
                          </Stack>
                        </Grid> */}

                        <Grid item xs={12}>
                          <Stack spacing={2}>
                            {values.Status === "RJ" && (
                              <TextField
                                name="ManagerComments"
                                id="ManagerComments"
                                label="Manager Comments"
                                multiline
                                rows={4}
                                variant="outlined"
                                fullWidth
                                focused
                                required
                                value={values.ManagerComments}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              />
                            )}

                            {values.Status === "B" && (
                              <TextField
                                disabled={mode === "V"}
                                required
                                name="blockedDate"
                                type="date"
                                id="blockedDate"
                                label="Blocked Date"
                                variant="standard"
                                focused
                                value={values.blockedDate}
                                onBlur={handleBlur}
                                onChange={handleChange}
                                error={
                                  !!touched.blockedDate && !!errors.blockedDate
                                }
                                helperText={
                                  touched.blockedDate && errors.blockedDate
                                }
                              />
                            )}

                            {values.Status === "B" && (
                              <TextField
                                disabled={mode === "V"}
                                name="blockedcomment"
                                id="blockedcomment"
                                label="Blocked Comments"
                                variant="standard"
                                fullWidth
                                focused
                                required
                                value={values.blockedcomment}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={
                                  !!touched.blockedcomment &&
                                  !!errors.blockedcomment
                                }
                                helperText={
                                  touched.blockedcomment &&
                                  errors.blockedcomment
                                }
                              />
                            )}

                            {/* {mode === "U" && (
                              <TextField
                                name="updatecomments"
                                id="updatecomments"
                                label="Update Comments"
                                multiline
                                rows={4}
                                variant="outlined"
                                fullWidth
                                focused
                                required
                                value={values.updatecomments}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                sx={{ gridColumn: "span 2" }}
                                error={
                                  !!touched.updatecomments &&
                                  !!errors.updatecomments
                                }
                                helperText={
                                  touched.updatecomments &&
                                  errors.updatecomments
                                }
                              />
                            )}
                             {mode == "U" ? (
                               <TextField
                        disabled={
                          data.Status === "Approved" ||
                          mode === "V"
                          // mode === "U"
                        }
                        name="SpentHours"
                        type="number"
                        id="SpentHours"                       
                        label="Spent Hours"
                        variant="standard"
                        fullWidth
                        focused
                        value={values.SpentHours}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={!!touched.SpentHours && !!errors.SpentHours}
                        helperText={touched.SpentHours && errors.SpentHours}
                        sx={{ gridColumn: "span 2" }}
                        InputProps={{
                          sx: { textAlign: "right" },
                          inputProps: {
                            style: { textAlign: "right" },
                          },
                        }}
                      />
                            ) : null} */}
                          </Stack>
                        </Grid>
                        {/* <Grid container spacing={2}>
                          
                          {mode === "U" && (
                            <Grid item xs={6} >
                              <TextField
                                name="updatecomments"
                                id="updatecomments"
                                label="Update Comments"
                                multiline
                                rows={4}
                                variant="outlined"
                                fullWidth
                                focused
                                required
                                value={values.updatecomments}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!touched.updatecomments && !!errors.updatecomments}
                                helperText={touched.updatecomments && errors.updatecomments}
                              />
                            </Grid>
                          )}

                          {mode === "U" && (
                            <Grid item xs={6}>
                              <TextField
                                disabled={
                                  data.Status === "Approved" ||
                                  mode === "V"
                                }
                                name="SpentHours"
                                type="number"
                                id="SpentHours"
                                label="Spend Hours"
                                variant="standard"
                                fullWidth
                                focused
                                value={values.SpentHours}
                                onChange={(e) => {
                                  const newSpent = Number(e.target.value || 0);

                                  // change in value
                                  const diff = newSpent - oldSpent;

                                  // update spent hours
                                  handleChange(e);

                                  // update actual hours correctly
                                  setFieldValue("actualHours", Number(values.actualHours || 0) + diff);

                                  // save newSpent as oldSpent for next change
                                  setOldSpent(newSpent);
                                }}
                                onBlur={handleBlur}
                                error={!!touched.SpentHours && !!errors.SpentHours}
                                helperText={touched.SpentHours && errors.SpentHours}
                                InputProps={{
                                  sx: { textAlign: "right" },
                                  inputProps: {
                                    style: { textAlign: "right" },
                                  },
                                }}
                              />
                            </Grid>
                          )}
                        </Grid> */}
                      </Grid>
                    </Box>
                  </React.Fragment>
                ) : (
                  false
                )}
                <Box
                  display="flex"
                  padding={1}
                  justifyContent="end"
                  mt="20px"
                  gap="20px"
                >
                  {mode == "IM" && (
                    <>
                      <TextField
                        name="purpose"
                        type="text"
                        id="purpose"
                        label="Purpose"
                        variant="standard"
                        focused
                        value={values.purpose}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.purpose && !!errors.purpose}
                        helperText={touched.purpose && errors.purpose}
                        sx={{ gridColumn: "span 2", height: "20px" }}
                        InputLabelProps={{ shrink: true }}
                      />

                      <Box display="flex" alignItems="center" gap={1}>
                        <FileUploadIconButton
                          onFileSelect={(file) => {
                            fileUpload(
                              file,
                              data.EmployeeID,
                              "upload",
                              "",
                              values.purpose
                            );
                            setFieldValue("purpose", "");
                          }}
                        />
                      </Box>
                    </>
                  )}
                  <LoadingButton
                    disabled={
                      data.Status === "Approved" || mode === "V" || mode == "IM"
                    }
                    color="secondary"
                    variant="contained"
                    type="submit"
                    loading={isLoading}
                  >
                    Save
                  </LoadingButton>
                  <Button
                    color="warning"
                    variant="contained"
                    onClick={() => {
                      navigate(-1);
                      // dispatch(
                      //   fetchListview(
                      //     "TR132",
                      //     "Scrum Task",
                      //     `EmployeesID='${EMPID}' AND DAILYTASKDATE BETWEEN '${fromDate}' AND '${toDate}'`,
                      //     ""
                      //   )
                      // );
                    }}
                  >
                    Cancel
                  </Button>
                  {scrumget.length > 0 ? (
                    <PDFDownloadLink
                      document={
                        <TaskupdatePDF
                          data={scrumget}
                          projectName={values.ProName?.Name}
                          Title={values.description}
                          // Imageurl= {baseurl1}
                          // HeaderImg= {HeaderImg}
                          // FooterImg= {FooterImg}
                          filters={{
                            Imageurl: baseurl1,
                            HeaderImg: HeaderImg,
                            FooterImg: FooterImg,
                          }}
                        // managerName={managerName}
                        />
                      }
                      fileName={`TaskUpdate.pdf`}
                      style={{ color: "#d32f2f", cursor: "pointer" }} // Red for PDF feel
                    >
                      {({ loading }) =>
                        loading ? (
                          <PictureAsPdfIcon
                            sx={{ fontSize: 24, opacity: 0.5 }}
                          />
                        ) : (
                          <PictureAsPdfIcon sx={{ fontSize: 24 }} />
                        )
                      }
                    </PDFDownloadLink>
                  ) : null}


                  {scrumget.length > 0 ? (
                    <FaFileExcel
                      size={20}
                      color="#1D6F42"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        TaskupdateExcel(
                          scrumget,
                          // {
                          //   Month: values.timemonth,
                          //   Year: values.timeyear,
                          //   EmployeeID: timeempData?.Name || EMPNAME,
                          // },
                          values.ProName?.Name,
                          values.description,

                        )
                      }
                    />
                  ) : (
                    null
                  )}
                  {/* </Box> */}
                </Box>

                {(mode !== "IM" || mode === "V") && scrumget.length > 0 ? (
                  <>
                    <Box
                      m="5px 0 0 0"
                      //height="500px"
                      display="flex"
                      height="50vh"
                      sx={{
                        "& .MuiDataGrid-root": {
                          // border: "none",
                        },
                        "& .MuiDataGrid-cell": {
                          // borderBottom: "none",
                        },
                        "& .name-column--cell": {
                          color: colors.greenAccent[300],
                        },
                        "& .MuiDataGrid-columnHeaders": {
                          backgroundColor: colors.blueAccent[800],
                          // borderBottom: "none",
                        },
                        "& .MuiDataGrid-virtualScroller": {
                          backgroundColor: colors.primary[400],
                        },
                        "& .MuiDataGrid-footerContainer": {
                          // borderTop: "none",
                          backgroundColor: colors.blueAccent[800],
                        },
                        "& .MuiCheckbox-root": {
                          color: `${colors.greenAccent[200]} !important`,
                        },
                        "& .odd-row": {
                          backgroundColor: "",
                          color: "", // Color for odd rows
                        },
                        "& .even-row": {
                          backgroundColor: "#d0edec",
                          color: "", // Color for even rows
                        },
                      }}
                    >
                      <Box
                        //flex={isEditing ? 1 : 1} // responsive width
                        flex={1} // responsive width
                        sx={{
                          width: "50%", // full width when not editing
                          transition: "width 0.3s ease-in-out",
                        }}
                      >
                        <DataGrid
                          sx={{
                            "& .MuiDataGrid-footerContainer": {
                              height: dataGridHeaderFooterHeight,
                              minHeight: dataGridHeaderFooterHeight,
                            },
                          }}
                          // checkboxSelection
                          rowHeight={dataGridRowHeight}
                          headerHeight={dataGridHeaderFooterHeight}
                          rows={scrumget}
                          //columns={columns}
                          columns={columns.map((col) =>
                            col.field === "actions"
                              ? {
                                ...col,
                                renderCell: (params) => (
                                  <Tooltip title="View">
                                    <IconButton
                                      color="primary"
                                      size="small"
                                      onClick={() =>
                                        handleEditClick(
                                          params.row,
                                          setFieldValue
                                        )
                                      }
                                    >
                                      <Visibility />
                                    </IconButton>
                                  </Tooltip>
                                ),
                              }
                              : col
                          )}
                          disableSelectionOnClick
                          getRowId={(row) => row.DailyTaskUpdateRecordID}
                          pageSize={pageSize}
                          onPageSizeChange={(newPageSize) =>
                            setPageSize(newPageSize)
                          }
                          rowsPerPageOptions={[5, 10, 20]}
                          pagination
                          components={{
                            Toolbar: Custombar,
                          }}
                          onStateChange={(stateParams) =>
                            setRowCount(stateParams.pagination.rowCount)
                          }
                          // loading={exploreLoading}
                          componentsProps={{
                            toolbar: {
                              showQuickFilter: true,
                              quickFilterProps: { debounceMs: 500 },
                            },
                          }}
                          getRowClassName={(params) =>
                            params.indexRelativeToCurrentPage % 2 === 0
                              ? "odd-row"
                              : "even-row"
                          }
                        />
                      </Box>

                      {/* {isEditing && ( */}
                      <Box
                        flex={1}
                        sx={{
                          marginLeft: "10px",
                          marginRight: "10px",
                          //width: "50%",
                          transition: "opacity 0.3s ease-in-out",
                        }}
                      >
                        <FormControl sx={{ display: "flex", gap: 3 }}>
                          <TextField
                            fullWidth
                            variant="standard"
                            type="text"
                            //value={values.CreatedDate}
                            value={
                              values.CreatedDate ||
                              (scrumget.length > 0
                                ? scrumget[0].DailyTaskUpdateCreatedDate
                                : "")
                            }
                            id="CreatedDate"
                            name="CreatedDate"
                            label="Created Date"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            error={
                              !!touched.CreatedDate && !!errors.CreatedDate
                            }
                            helperText={
                              touched.CreatedDate && errors.CreatedDate
                            }
                            focused
                            InputProps={{
                              inputProps: { readOnly: true },
                            }}
                          />

                          <TextField
                            fullWidth
                            variant="standard"
                            type="text"
                            //value={values.CreatedTime}
                            value={
                              values.CreatedTime ||
                              (scrumget.length > 0
                                ? scrumget[0].DailyTaskUpdateCreatedTime
                                : "")
                            }
                            id="CreatedTime"
                            name="CreatedTime"
                            label="Created Time"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            error={
                              !!touched.CreatedTime && !!errors.CreatedTime
                            }
                            helperText={
                              touched.CreatedTime && errors.CreatedTime
                            }
                            focused
                            InputProps={{
                              inputProps: { readOnly: true },
                            }}
                          />
                          <TextField
                            fullWidth
                            variant="standard"
                            type="text"
                            value={
                              values.Hours ||
                              (scrumget.length > 0
                                ? scrumget[0].SpendHours
                                : "")
                            }
                            id="Hours"
                            name="Hours"
                            label="Spend Hours"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            error={!!touched.Hours && !!errors.Hours}
                            helperText={touched.Hours && errors.Hours}
                            focused
                            InputProps={{
                              readOnly: true,
                              inputProps: { style: { textAlign: "right" } },
                            }}
                          />

                          <TextField
                            fullWidth
                            variant="standard"
                            type="text"
                            //value={values.Comments}
                            value={
                              values.Comments ||
                              (scrumget.length > 0
                                ? scrumget[0].DailyTaskUpdateComments
                                : "")
                            }
                            id="Comments"
                            name="Comments"
                            label="Comments"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            error={!!touched.Comments && !!errors.Comments}
                            helperText={touched.Comments && errors.Comments}
                            focused
                            multiline
                            sx={{ gridColumn: "span 2" }}
                            rows={4}
                            InputProps={{
                              inputProps: { readOnly: true },
                            }}
                          />
                        </FormControl>
                      </Box>
                    </Box>
                  </>
                ) : null}
              </form>
            )}
          </Formik>

          <Box m={1} display="flex" gap={2}>
            {/* Left Side: Upload File Table */}
            {mode === "IM" && files.length > 0 ? (
              <Box flex={1}>
                <Paper elevation={3} sx={{ padding: 2 }}>
                  <TableContainer component={Paper}>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell width={20}>
                            <strong>SL#</strong>
                          </TableCell>
                          <TableCell>
                            <strong>Uploaded Date</strong>
                          </TableCell>
                          <TableCell>
                            <strong>Filename</strong>
                          </TableCell>
                          {is003Subscription && (
                            <TableCell>
                              <strong>Comments</strong>
                            </TableCell>
                          )}
                          <TableCell>
                            <strong>Purpose</strong>
                          </TableCell>
                          <TableCell>
                            <strong>Source</strong>
                          </TableCell>
                          <TableCell>
                            <strong>View</strong>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {files.length === 0 ? (
                          <TableRow>
                            <TableCell colSpan={5} align="center">
                              No files uploaded yet.
                            </TableCell>
                          </TableRow>
                        ) : (
                          files.map((file, index) => (
                            <TableRow key={file.id || index}>
                              <TableCell>{index + 1}</TableCell>
                              <TableCell>{file.uploadedDate}</TableCell>
                              <TableCell>{file.filename}</TableCell>
                              {is003Subscription && (
                                <TableCell>
                                  <strong>Comments</strong>
                                </TableCell>
                              )}
                              <TableCell>{file.purpose}</TableCell>
                              <TableCell>{file.source}</TableCell>
                              <TableCell>
                                <Tooltip title="Open File">
                                  <IconButton
                                    color="primary"
                                    component="a"
                                    href={is003Subscription ? `${getempattach}uploads/images/${file.filename}` : file.url}
                                    // href={file.url}
                                    // href={`${getempattach}uploads/images/${file.filename}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    size="small"
                                  >
                                    <OpenInNewIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="delete">
                                  <IconButton
                                    color="error"
                                    onClick={() =>
                                      fileUpload(
                                        file.filename,
                                        data.EmployeesID,
                                        "delete",
                                        file.id,
                                        file.purpose
                                      )
                                    }
                                    size="small"
                                  >
                                    <DeleteForeverIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              </TableCell>
                            </TableRow>
                          ))
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
              </Box>
            ) : null}
            {mode !== "IM" && mode !== "A" ? (
              <Box flex={1}>
                <Paper elevation={3} sx={{ padding: 2 }}>
                  <div style={{ height: "400px" }}>
                    <Chart
                      width={500}
                      options={chartOptions}
                      series={
                        data.taskTrack
                          ? [
                            {
                              name: "Task Status",
                              data: data.taskTrack,
                            },
                          ]
                          : []
                      }
                      type="line"
                      height={350}
                    />
                  </div>
                </Paper>
              </Box>
            ) : null}
          </Box>
        </Paper>
      ) : (
        false
      )}
      {show == "1" ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          <Formik
            initialValues={Productinitialvalues}
            enableReinitialize={true}
            validationSchema={validationSchema4}
            onSubmit={(values, { resetForm }) => {
              setTimeout(() => {
                ProductSaveFn(values, resetForm, false);
              }, 100);
            }}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
              resetForm,
              setFieldValue,
              setFieldTouched,
            }) => (
              <form
                onSubmit={handleSubmit}
                onReset={() => {
                  selectCellRowData({
                    rowData: {},
                    mode: "A",
                    field: "",
                    type: "product",
                  });
                  resetForm();
                }}
              >
                <Box
                  display="grid"
                  gap={formGap}
                  padding={1}
                  gridTemplateColumns="repeat(2 , minMax(0,1fr))"
                  // gap="30px"
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 2",
                    },
                  }}
                >
                  <FormControl sx={{ gap: formGap }}>
                    {/* <TextField
                      fullWidth
                      variant="standard"
                      type="text"
                      id="code"
                      name="code"
                      value={values.code}
                      label="Code"
                      focused
                      inputProps={{ readOnly: true }}
                    /> */}
                    <TextField
                      name="date"
                      type="date"
                      id="date"
                      label="Date"
                      variant="standard"
                      focused
                      format="MM-DD-YYYY"
                      value={values.date}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={!!touched.date && !!errors.date}
                      helperText={touched.date && errors.date}
                      inputProps={{ readOnly: true }}
                    />

                    <TextField
                      fullWidth
                      variant="standard"
                      type="text"
                      id="description"
                      name="description"
                      value={values.description}
                      label="Title"
                      focused
                      inputProps={{ readOnly: true }}
                    />
                  </FormControl>
                  <Stack
                    sx={{
                      //    width: {sm:'100%',md:'100%',lg:'100%'},
                      //gridColumn: "span 2",
                      alignContent: "center",
                      justifyContent: "center",
                      alignItems: "center",
                      position: "relative",
                      right: "0px",
                    }}
                  >
                    <Avatar
                      variant="rounded"
                      src={userimg}
                      sx={{ width: "200px", height: "120px" }}
                    />
                  </Stack>

                  <Box
                    m="5px 0 0 0"
                    //height={dataGridHeight}
                    height="50vh"
                    sx={{
                      "& .MuiDataGrid-root": {
                        border: "none",
                      },
                      "& .MuiDataGrid-cell": {
                        borderBottom: "none",
                      },
                      "& .name-column--cell": {
                        color: colors.greenAccent[300],
                      },
                      "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: colors.blueAccent[800],
                        borderBottom: "none",
                      },
                      "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: colors.primary[400],
                      },
                      "& .MuiDataGrid-footerContainer": {
                        borderTop: "none",
                        backgroundColor: colors.blueAccent[800],
                      },
                      "& .MuiCheckbox-root": {
                        color: `${colors.greenAccent[200]} !important`,
                      },
                      "& .odd-row": {
                        backgroundColor: "",
                        color: "", // Color for odd rows
                      },
                      "& .even-row": {
                        backgroundColor: "#D3D3D3",
                        color: "", // Color for even rows
                      },
                    }}
                  >
                    <DataGrid
                      sx={{
                        "& .MuiDataGrid-footerContainer": {
                          height: dataGridHeaderFooterHeight,
                          minHeight: dataGridHeaderFooterHeight,
                        },
                      }}
                      rows={explorelistViewData}
                      columns={newcolumn}
                      disableSelectionOnClick
                      getRowId={(row) => row.RecordID}
                      rowHeight={dataGridRowHeight}
                      headerHeight={dataGridHeaderFooterHeight}
                      pageSize={pageSize}
                      onPageSizeChange={(newPageSize) =>
                        setPageSize(newPageSize)
                      }
                      onCellClick={(params) => {
                        selectCellRowData({
                          rowData: params.row,
                          mode: "E",
                          field: params.field,
                          setFieldValue,
                          type: "product",
                        });
                      }}
                      rowsPerPageOptions={[5, 10, 20]}
                      pagination
                      // components={{
                      //   Toolbar: ProductReset,
                      // }}
                      components={{
                        // Toolbar: () => (
                        //   <ProductReset
                        //     onAdd={() => {
                        //       selectCellRowData({
                        //         rowData: {},
                        //         mode: "A",
                        //         type: "product",
                        //         setFieldValue,
                        //       });
                        //       resetForm();
                        //     }}
                        //   />
                        // ),
                        Toolbar: Employee,
                      }}
                      onStateChange={(stateParams) =>
                        setRowCount(stateParams.pagination.rowCount)
                      }
                      getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0
                          ? "odd-row"
                          : "even-row"
                      }
                      loading={exploreLoading}
                      componentsProps={{
                        toolbar: {
                          showQuickFilter: true,
                          quickFilterProps: { debounceMs: 500 },
                        },
                      }}
                    />
                  </Box>

                  <FormControl sx={{ gap: formGap }}>
                    {/* <CheckinAutocomplete
                      name="items"
                      label="Item"
                      variant="outlined"
                      id="items"
                      value={values.items}
                      onChange={(newValue) => {
                        setFieldValue("items", {
                          RecordID: newValue.RecordID,
                          Code: newValue.Code,
                          Name: newValue.Name,
                        });
                        setFieldValue(
                          "itemCategoryID",
                          newValue.CrmItemCategoryID || ""
                        );
                        setFieldValue(
                          "itemGroupID",
                          newValue.CrmItemGroupID || ""
                        );
                        console.log(newValue, "--newvalue items");
                        console.log(newValue.RecordID, "items RecordID");
                      }}
                      error={!!touched.items && !!errors.items}
                      helperText={touched.items && errors.items}
                      url={`${listViewurl}?data={"Query":{"AccessID":"2137","ScreenName":"Items","Filter":"CompanyID='${compID}' AND ItemsDesc ='Product'","Any":""}}`}
                    /> */}
                    <CheckinAutocomplete
                      name="productItems"
                      //label="Item"
                      label={
                        <>
                          Item
                          <span style={{ color: "red", fontSize: "20px" }}>
                            *
                          </span>
                        </>
                      }
                      id="productItems"
                      value={values.productItems}
                      onChange={(newValue) => {
                        setFieldValue("productItems", {
                          RecordID: newValue.RecordID,
                          Code: newValue.Code,
                          Name: newValue.Name,
                        });
                        setFieldTouched("productItems", true);

                        setFieldValue(
                          "productCategoryID",
                          newValue.CrmItemCategoryID || ""
                        );
                        setFieldValue(
                          "productGroupID",
                          newValue.CrmItemGroupID || ""
                        );
                        // Auto-fill from dropdown
                        setFieldValue(
                          "productUnit",
                          newValue.ConsumptionUOM || ""
                        );
                        setFieldValue("productRate", newValue.Price || "");

                        // Recalculate amount
                        const qty = values.productQty || 1;
                        setFieldValue(
                          "productAmount",
                          (Number(newValue.Price) * Number(qty)).toFixed(2)
                        );

                        setTimeout(() => {
                          commentsRef.current?.focus();
                        }, 100);
                      }}
                      error={!!touched.productItems && !!errors.productItems}
                      helperText={touched.productItems && errors.productItems}
                      url={`${listViewurl}?data={"Query":{"AccessID":"2137","ScreenName":"Items","Filter":"CompanyID='${compID}' AND ItemsDesc ='Product'","Any":""}}`}
                    />
                    {/* <TextField
                      fullWidth
                      variant="standard"
                      type="text"
                      value={values.unit}
                      id="unit"
                      name="unit"
                      label="Unit"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={!!touched.unit && !!errors.unit}
                      helperText={touched.unit && errors.unit}
                      sx={{
                        backgroundColor: "#ffffff",
                        "& .MuiFilledInput-root": {
                          backgroundColor: "#ffffff",
                        },
                      }}
                      focused
                      inputProps={{ maxLength: 30 }}
                    /> */}
                    <TextField
                      fullWidth
                      variant="standard"
                      id="productUnit"
                      name="productUnit"
                      label="Unit"
                      // label={
                      //   <>
                      //     Unit
                      //     <span style={{ color: "red", fontSize: "20px" }}>
                      //       *
                      //     </span>
                      //   </>
                      // }
                      value={values.productUnit}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      focused
                      error={!!touched.productUnit && !!errors.productUnit}
                      helperText={touched.productUnit && errors.productUnit}
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                    {/* <TextField
                      fullWidth
                      variant="standard"
                      type="text"
                      value={values.productRate}
                      id="productRate"
                      name="productRate"
                      label="Rate"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={!!touched.productRate && !!errors.productRate}
                      helperText={touched.productRate && errors.productRate}
                      sx={{
                        backgroundColor: "#ffffff", 
                        "& .MuiFilledInput-root": {
                          backgroundColor: "#ffffff", 
                        },
                      }}
                      focused
                      inputProps={{ maxLength: 90 }}
                      InputProps={{
                        inputProps: {
                          style: { textAlign: "right" },
                        },
                      }}
                    /> */}
                    <TextField
                      fullWidth
                      variant="standard"
                      type="number"
                      value={values.productRate}
                      id="productRate"
                      name="productRate"
                      label="Rate"
                      // label={
                      //   <>
                      //     Rate
                      //     <span style={{ color: "red", fontSize: "20px" }}>
                      //       *
                      //     </span>
                      //   </>
                      // }
                      onBlur={handleBlur}
                      // onChange={(e) => {
                      //   const rate = e.target.value;
                      //   setFieldValue("productRate", rate);

                      //   // Auto-update Amount
                      //   const qty = values.productQty || 0;
                      //   setFieldValue(
                      //     "productAmount",
                      //     (Number(rate) * Number(qty)).toFixed(2)
                      //   );
                      // }}

                      onChange={(e) => {
                        const rate = e.target.value || 0;
                        setFieldValue("productRate", rate);

                        const qty = values.productQty || 0;
                        setFieldValue("productAmount", (qty * rate).toFixed(2));
                      }}
                      error={!!touched.productRate && !!errors.productRate}
                      helperText={touched.productRate && errors.productRate}
                      sx={{
                        backgroundColor: "#ffffff",
                        "& .MuiFilledInput-root": {
                          backgroundColor: "#ffffff",
                        },
                      }}
                      focused
                      inputProps={{ maxLength: 90 }}
                      InputProps={{
                        readOnly: true,
                        inputProps: { style: { textAlign: "right" } },
                      }}
                    />

                    {/* <TextField
                      fullWidth
                      variant="standard"
                      type="text"
                      value={values.productQty}
                      id="productQty"
                      name="productQty"
                      label="Quantity"
                      // required
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={!!touched.productQty && !!errors.productQty}
                      helperText={touched.productQty && errors.productQty}
                      sx={{
                        backgroundColor: "#ffffff",
                        "& .MuiFilledInput-root": {
                          backgroundColor: "#ffffff",
                        },
                      }}
                      focused
                      inputProps={{ maxLength: 90 }}
                      InputProps={{
                        inputProps: {
                          style: { textAlign: "right" },
                        },
                      }}
                    /> */}
                    <TextField
                      fullWidth
                      variant="standard"
                      type="number"
                      value={values.productQty}
                      id="productQty"
                      name="productQty"
                      label="Quantity"
                      // label={
                      //   <>
                      //     Quantity
                      //     <span style={{ color: "red", fontSize: "20px" }}>
                      //       *
                      //     </span>
                      //   </>
                      // }
                      onBlur={handleBlur}
                      // onChange={(e) => {
                      //   const qty = e.target.value;
                      //   setFieldValue("productQty", qty);

                      //   // Auto-update Amount
                      //   const rate = values.productRate || 0;
                      //   setFieldValue(
                      //     "productAmount",
                      //     (Number(rate) * Number(qty)).toFixed(2)
                      //   );
                      // }}

                      onChange={(e) => {
                        const qty = e.target.value;
                        setFieldValue("productQty", qty);

                        const rate = values.productRate || 0;
                        setFieldValue("productAmount", (qty * rate).toFixed(2));
                      }}
                      error={!!touched.productQty && !!errors.productQty}
                      helperText={touched.productQty && errors.productQty}
                      sx={{
                        backgroundColor: "#ffffff",
                        "& .MuiFilledInput-root": {
                          backgroundColor: "#ffffff",
                        },
                      }}
                      focused
                      inputProps={{ maxLength: 90 }}
                      InputProps={{
                        inputProps: { style: { textAlign: "right" } },
                      }}
                    />

                    {/* <TextField
                      fullWidth
                      variant="standard"
                      type="text"
                      value={values.productAmount}
                      id="productAmount"
                      name="productAmount"
                      label="Amount"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={!!touched.productAmount && !!errors.productAmount}
                      helperText={touched.productAmount && errors.productAmount}
                      sx={{
                        backgroundColor: "#ffffff",
                        "& .MuiFilledInput-root": {
                          backgroundColor: "#ffffff",
                        },
                      }}
                      focused
                      inputProps={{ maxLength: 90 }}
                      InputProps={{
                        inputProps: {
                          style: { textAlign: "right" },
                        },
                      }}
                    /> */}
                    <TextField
                      fullWidth
                      variant="standard"
                      type="number"
                      value={values.productAmount}
                      id="productAmount"
                      name="productAmount"
                      label="Amount"
                      onBlur={handleBlur}
                      InputProps={{
                        readOnly: true,
                        inputProps: { style: { textAlign: "right" } },
                      }}
                      sx={{
                        backgroundColor: "#ffffff",
                        "& .MuiFilledInput-root": {
                          backgroundColor: "#ffffff",
                        },
                      }}
                      focused
                    />

                    <TextField
                      fullWidth
                      variant="standard"
                      type="text"
                      value={values.productcomments}
                      id="productcomments"
                      name="productcomments"
                      inputRef={commentsRef} // <-- ADD THIS
                      label="Comments"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      // error={
                      //   !!touched.productcomments && !!errors.productcomments
                      // }
                      // helperText={
                      //   touched.productcomments && errors.productcomments
                      // }
                      sx={{
                        //gridColumn: "span 2",
                        backgroundColor: "#ffffff", // Set the background to white
                        "& .MuiFilledInput-root": {
                          backgroundColor: "#ffffff", // Ensure the filled variant also has a white background
                        },
                      }}
                      focused
                      autoFocus
                      multiline
                      inputProps={{ maxLength: 90 }}
                    />
                    {TaskSource === "Sprint" && (
                      <Box>
                        <Field
                          //  size="small"
                          type="checkbox"
                          name="productAdditionalBillable"
                          id="productAdditionalBillable"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          as={Checkbox}
                          label="Additionally Billable"
                          sx={{
                            padding: "0px 5px 0px 0px",
                          }}
                        />
                        <FormLabel focused sx={{ color: "black !important" }}>
                          Additionally Billable
                        </FormLabel>
                      </Box>)}
                  </FormControl>
                </Box>
                <Box
                  display="flex"
                  justifyContent="end"
                  padding={1}
                  // style={{ marginTop: "-40px" }}
                  gap={2}
                >
                  {/* {YearFlag == "true" ? ( */}
                  <LoadingButton
                    color="secondary"
                    variant="contained"
                    type="submit"
                    loading={isLoading}
                    disabled={data.TaskSource === "Sprint" && data.Status === "AP"}
                  >
                    Save
                  </LoadingButton>
                  {/* ) : (
                      <Button
                        color="secondary"
                        variant="contained"
                        disabled={true}
                      >
                        Save
                      </Button>
                    )}
                    {YearFlag == "true" ? ( */}
                  <Button
                    color="error"
                    variant="contained"
                    onClick={() => {
                      Swal.fire({
                        title: errorMsgData.Warningmsg.Delete,
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Confirm",
                      }).then((result) => {
                        if (result.isConfirmed) {
                          ProductSaveFn(values, resetForm, "harddelete");
                        } else {
                          return;
                        }
                      });
                    }}
                    //disabled={funMode === "A"}
                    disabled={funMode === "A" || (data.TaskSource === "Sprint" && data.Status === "AP")}

                  >
                    Delete
                  </Button>
                  {/* ) : (
                      <Button color="error" variant="contained" disabled={true}>
                        Delete
                      </Button>
                    )} */}
                  <Button
                    type="reset"
                    color="warning"
                    variant="contained"
                    onClick={() => {
                      setScreen(0);
                    }}
                  >
                    Cancel
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
        </Paper>
      ) : (
        false
      )}
      {show == "2" ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          <Formik
            initialValues={Materialinitialvalues}
            enableReinitialize={true}
            validationSchema={validationSchema2}
            onSubmit={(values, { resetForm }) => {
              setTimeout(() => {
                MaterialsSaveFn(values, resetForm, false);
              }, 100);
            }}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
              resetForm,
              setFieldValue,
              setFieldTouched,
            }) => (
              <form
                onSubmit={handleSubmit}
                onReset={() => {
                  selectCellRowData({
                    rowData: {},
                    mode: "A",
                    field: "",
                    type: "material",
                  });
                  resetForm();
                }}
              >
                <Box
                  display="grid"
                  gap={formGap}
                  padding={1}
                  gridTemplateColumns="repeat(2 , minMax(0,1fr))"
                  // gap="30px"
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 2",
                    },
                  }}
                >
                  <FormControl sx={{ gap: formGap }}>
                    {/* <TextField
                      fullWidth
                      variant="standard"
                      type="text"
                      id="code"
                      name="code"
                      value={values.code}
                      label="Code"
                      focused
                      inputProps={{ readOnly: true }}
                    /> */}
                    <TextField
                      name="date"
                      type="date"
                      id="date"
                      label="Date"
                      variant="standard"
                      focused
                      format="MM-DD-YYYY"
                      value={values.date}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={!!touched.date && !!errors.date}
                      helperText={touched.date && errors.date}
                      inputProps={{ readOnly: true }}
                    />

                    <TextField
                      fullWidth
                      variant="standard"
                      type="text"
                      id="description"
                      name="description"
                      value={values.description}
                      label="Title"
                      focused
                      inputProps={{ readOnly: true }}
                    />
                  </FormControl>
                  <Stack
                    sx={{
                      //    width: {sm:'100%',md:'100%',lg:'100%'},
                      //gridColumn: "span 2",
                      alignContent: "center",
                      justifyContent: "center",
                      alignItems: "center",
                      position: "relative",
                      right: "0px",
                    }}
                  >
                    <Avatar
                      variant="rounded"
                      src={userimg}
                      sx={{ width: "200px", height: "120px" }}
                    />
                  </Stack>

                  <Box
                    m="5px 0 0 0"
                    //height={dataGridHeight}
                    height="50vh"
                    sx={{
                      "& .MuiDataGrid-root": {
                        border: "none",
                      },
                      "& .MuiDataGrid-cell": {
                        borderBottom: "none",
                      },
                      "& .name-column--cell": {
                        color: colors.greenAccent[300],
                      },
                      "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: colors.blueAccent[800],
                        borderBottom: "none",
                      },
                      "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: colors.primary[400],
                      },
                      "& .MuiDataGrid-footerContainer": {
                        borderTop: "none",
                        backgroundColor: colors.blueAccent[800],
                      },
                      "& .MuiCheckbox-root": {
                        color: `${colors.greenAccent[200]} !important`,
                      },
                      "& .odd-row": {
                        backgroundColor: "",
                        color: "", // Color for odd rows
                      },
                      "& .even-row": {
                        backgroundColor: "#D3D3D3",
                        color: "", // Color for even rows
                      },
                    }}
                  >
                    <DataGrid
                      sx={{
                        "& .MuiDataGrid-footerContainer": {
                          height: dataGridHeaderFooterHeight,
                          minHeight: dataGridHeaderFooterHeight,
                        },
                      }}
                      rows={explorelistViewData}
                      //columns ={explorelistViewcolumn}
                      columns={newcolumn}
                      disableSelectionOnClick
                      getRowId={(row) => row.RecordID}
                      rowHeight={dataGridRowHeight}
                      headerHeight={dataGridHeaderFooterHeight}
                      pageSize={pageSize}
                      onPageSizeChange={(newPageSize) =>
                        setPageSize(newPageSize)
                      }
                      onCellClick={(params) => {
                        selectCellRowData({
                          rowData: params.row,
                          mode: "E",
                          field: params.field,
                          setFieldValue,
                          type: "material",
                        });
                      }}
                      rowsPerPageOptions={[5, 10, 20]}
                      pagination
                      // components={{
                      //   Toolbar: Employee,
                      // }}
                      components={{
                        Toolbar: () => (
                          <MaterialReset
                            onAdd={() => {
                              selectCellRowData({
                                rowData: {},
                                mode: "A",
                                type: "material",
                                setFieldValue,
                              });
                              resetForm();
                            }}
                          />
                        ),
                      }}
                      onStateChange={(stateParams) =>
                        setRowCount(stateParams.pagination.rowCount)
                      }
                      getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0
                          ? "odd-row"
                          : "even-row"
                      }
                      loading={exploreLoading}
                      componentsProps={{
                        toolbar: {
                          showQuickFilter: true,
                          quickFilterProps: { debounceMs: 500 },
                        },
                      }}
                    />
                  </Box>

                  <FormControl sx={{ gap: formGap }}>
                    <CheckinAutocomplete
                      name="materialItems"
                      //label="Item"
                      label={
                        <>
                          Item
                          <span style={{ color: "red", fontSize: "20px" }}>
                            *
                          </span>
                        </>
                      }
                      variant="outlined"
                      id="materialItems"
                      value={values.materialItems}
                      onChange={(newValue) => {
                        setFieldValue("materialItems", {
                          RecordID: newValue.RecordID,
                          Code: newValue.Code,
                          Name: newValue.Name,
                        });
                        setFieldTouched("materialItems", true);

                        setFieldValue(
                          "materialCategoryID",
                          newValue.CrmItemCategoryID || ""
                        );
                        setFieldValue(
                          "materialGroupID",
                          newValue.CrmItemGroupID || ""
                        );

                        setFieldValue(
                          "materialUnit",
                          newValue.ConsumptionUOM || ""
                        );
                        setFieldValue("materialRate", newValue.Price || "");

                        // Recalculate amount
                        const qty = values.materialQty || 1;
                        setFieldValue(
                          "materialAmount",
                          (Number(newValue.Price) * Number(qty)).toFixed(2)
                        );

                        setTimeout(() => {
                          commentsRef.current?.focus();
                        }, 100);
                        console.log(newValue, "--newvalue items");
                        console.log(newValue.RecordID, "items RecordID");
                      }}
                      error={!!touched.materialItems && !!errors.materialItems}
                      helperText={touched.materialItems && errors.materialItems}
                      url={`${listViewurl}?data={"Query":{"AccessID":"2138","ScreenName":"Items","Filter":"CompanyID='${compID}' AND ItemsDesc ='Material'","Any":""}}`}
                    />
                    <TextField
                      fullWidth
                      variant="standard"
                      type="text"
                      value={values.materialUnit}
                      id="materialUnit"
                      name="materialUnit"
                      label="Unit"
                      // label={
                      //   <>
                      //     Unit
                      //     <span style={{ color: "red", fontSize: "20px" }}>
                      //       *
                      //     </span>
                      //   </>
                      // }
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={!!touched.materialUnit && !!errors.materialUnit}
                      helperText={touched.materialUnit && errors.materialUnit}
                      sx={{
                        backgroundColor: "#ffffff",
                        "& .MuiFilledInput-root": {
                          backgroundColor: "#ffffff",
                        },
                      }}
                      focused
                      InputProps={{
                        readOnly: true,
                      }}
                      inputProps={{ maxLength: 30 }}
                    />

                    <TextField
                      fullWidth
                      variant="standard"
                      type="number"
                      value={values.materialRate}
                      id="materialRate"
                      name="materialRate"
                      label="Rate"
                      // label={
                      //   <>
                      //     Rate
                      //     <span style={{ color: "red", fontSize: "20px" }}>
                      //       *
                      //     </span>
                      //   </>
                      // }
                      onBlur={handleBlur}
                      // onChange={(e) => {
                      //   const rate = e.target.value;
                      //   setFieldValue("materialRate", rate);

                      //   // Auto-update Amount
                      //   const qty = values.materialQty || 0;
                      //   setFieldValue(
                      //     "materialAmount",
                      //     (Number(rate) * Number(qty)).toFixed(2)
                      //   );
                      // }}
                      onChange={(e) => {
                        const rate = e.target.value || 0;
                        setFieldValue("materialRate", rate);

                        const qty = values.materialQty || 0;
                        setFieldValue(
                          "materialAmount",
                          (qty * rate).toFixed(2)
                        );
                      }}
                      error={!!touched.materialRate && !!errors.materialRate}
                      helperText={touched.materialRate && errors.materialRate}
                      sx={{
                        backgroundColor: "#ffffff",
                        "& .MuiFilledInput-root": {
                          backgroundColor: "#ffffff",
                        },
                      }}
                      focused
                      inputProps={{ maxLength: 90 }}
                      InputProps={{
                        readOnly: true,
                        inputProps: { style: { textAlign: "right" } },
                      }}
                    // InputProps={{
                    //   inputProps: { style: { textAlign: "right" } },
                    // }}
                    />

                    <TextField
                      fullWidth
                      variant="standard"
                      type="number"
                      value={values.materialQty}
                      id="materialQty"
                      name="materialQty"
                      label="Quantity"
                      // label={
                      //   <>
                      //     Quantity
                      //     <span style={{ color: "red", fontSize: "20px" }}>
                      //       *
                      //     </span>
                      //   </>
                      // }
                      onBlur={handleBlur}
                      // onChange={(e) => {
                      //   const qty = e.target.value;
                      //   setFieldValue("materialQty", qty);

                      //   const rate = values.materialRate || 0;
                      //   setFieldValue(
                      //     "materialAmount",
                      //     (Number(rate) * Number(qty)).toFixed(2)
                      //   );
                      // }}
                      onChange={(e) => {
                        const qty = e.target.value;
                        setFieldValue("materialQty", qty);

                        const rate = values.materialRate || 0;
                        setFieldValue(
                          "materialAmount",
                          (qty * rate).toFixed(2)
                        );
                      }}
                      error={!!touched.materialQty && !!errors.materialQty}
                      helperText={touched.materialQty && errors.materialQty}
                      sx={{
                        backgroundColor: "#ffffff",
                        "& .MuiFilledInput-root": {
                          backgroundColor: "#ffffff",
                        },
                      }}
                      focused
                      inputProps={{ maxLength: 90 }}
                      InputProps={{
                        inputProps: { style: { textAlign: "right" } },
                      }}
                    />
                    <TextField
                      fullWidth
                      variant="standard"
                      type="number"
                      value={values.materialAmount}
                      id="materialAmount"
                      name="materialAmount"
                      label="Amount"
                      onBlur={handleBlur}
                      InputProps={{
                        readOnly: true,
                        inputProps: { style: { textAlign: "right" } },
                      }}
                      sx={{
                        backgroundColor: "#ffffff",
                        "& .MuiFilledInput-root": {
                          backgroundColor: "#ffffff",
                        },
                      }}
                      focused
                    />

                    <TextField
                      fullWidth
                      variant="standard"
                      type="text"
                      value={values.materialcomments}
                      id="materialcomments"
                      name="materialcomments"
                      label="Comments"
                      inputRef={commentsRef} // <-- ADD THIS
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={
                        !!touched.materialcomments && !!errors.materialcomments
                      }
                      helperText={
                        touched.materialcomments && errors.materialcomments
                      }
                      sx={{
                        //gridColumn: "span 2",
                        backgroundColor: "#ffffff", // Set the background to white
                        "& .MuiFilledInput-root": {
                          backgroundColor: "#ffffff", // Ensure the filled variant also has a white background
                        },
                      }}
                      focused
                      multiline
                      inputProps={{ maxLength: 90 }}
                    />
                    {TaskSource === "Sprint" && (
                      <Box>
                        <Field
                          //  size="small"
                          type="checkbox"
                          name="materialAdditionalBillable"
                          id="materialAdditionalBillable"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          as={Checkbox}
                          label="Additionally Billable"
                          sx={{
                            padding: "0px 5px 0px 0px",
                          }}
                        />
                        <FormLabel focused sx={{ color: "black !important" }}>
                          Additionally Billable
                        </FormLabel>
                      </Box>)}
                  </FormControl>
                </Box>
                <Box
                  display="flex"
                  justifyContent="end"
                  padding={1}
                  // style={{ marginTop: "-40px" }}
                  gap={2}
                >
                  {/* {YearFlag == "true" ? ( */}
                  <LoadingButton
                    color="secondary"
                    variant="contained"
                    type="submit"
                    loading={isLoading}
                    disabled={data.TaskSource === "Sprint" && data.Status === "AP"}

                  >
                    Save
                  </LoadingButton>
                  {/* ) : (
                      <Button
                        color="secondary"
                        variant="contained"
                        disabled={true}
                      >
                        Save
                      </Button>
                    )}
                    {YearFlag == "true" ? ( */}
                  <Button
                    color="error"
                    variant="contained"
                    onClick={() => {
                      Swal.fire({
                        title: errorMsgData.Warningmsg.Delete,
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Confirm",
                      }).then((result) => {
                        if (result.isConfirmed) {
                          MaterialsSaveFn(values, resetForm, "harddelete");
                        } else {
                          return;
                        }
                      });
                    }}
                    //disabled={funMode == "A"}
                    disabled={funMode === "A" || (data.TaskSource === "Sprint" && data.Status === "AP")}

                  >
                    Delete
                  </Button>
                  {/* ) : (
                      <Button color="error" variant="contained" disabled={true}>
                        Delete
                      </Button>
                    )} */}
                  <Button
                    type="reset"
                    color="warning"
                    variant="contained"
                    onClick={() => {
                      setScreen(0);
                    }}
                  >
                    Cancel
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
        </Paper>
      ) : (
        false
      )}
      {show == "3" ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          <Formik
            initialValues={Serviceinitialvalues}
            enableReinitialize={true}
            validationSchema={validationSchema3}
            onSubmit={(values, { resetForm }) => {
              setTimeout(() => {
                ServiceSaveFn(values, resetForm, false);
              }, 100);
            }}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
              resetForm,
              setFieldValue,
              setFieldTouched,
            }) => (
              <form
                onSubmit={handleSubmit}
                onReset={() => {
                  selectCellRowData({
                    rowData: {},
                    mode: "A",
                    field: "",
                    type: "service",
                  });
                  resetForm();
                }}
              >
                <Box
                  display="grid"
                  gap={formGap}
                  padding={1}
                  gridTemplateColumns="repeat(2 , minMax(0,1fr))"
                  // gap="30px"
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 2",
                    },
                  }}
                >
                  <FormControl sx={{ gap: formGap }}>
                    {/* <TextField
                      fullWidth
                      variant="standard"
                      type="text"
                      id="code"
                      name="code"
                      value={values.code}
                      label="Code"
                      focused
                      inputProps={{ readOnly: true }}
                    /> */}
                    <TextField
                      name="date"
                      type="date"
                      id="date"
                      label="Date"
                      variant="standard"
                      focused
                      format="MM-DD-YYYY"
                      value={values.date}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={!!touched.date && !!errors.date}
                      helperText={touched.date && errors.date}
                      inputProps={{ readOnly: true }}
                    />

                    <TextField
                      fullWidth
                      variant="standard"
                      type="text"
                      id="description"
                      name="description"
                      value={values.description}
                      label="Title"
                      focused
                      inputProps={{ readOnly: true }}
                    />
                  </FormControl>
                  <Stack
                    sx={{
                      //    width: {sm:'100%',md:'100%',lg:'100%'},
                      //gridColumn: "span 2",
                      alignContent: "center",
                      justifyContent: "center",
                      alignItems: "center",
                      position: "relative",
                      right: "0px",
                    }}
                  >
                    <Avatar
                      variant="rounded"
                      src={userimg}
                      sx={{ width: "200px", height: "120px" }}
                    />
                  </Stack>

                  <Box
                    m="5px 0 0 0"
                    //height={dataGridHeight}
                    height="50vh"
                    sx={{
                      "& .MuiDataGrid-root": {
                        border: "none",
                      },
                      "& .MuiDataGrid-cell": {
                        borderBottom: "none",
                      },
                      "& .name-column--cell": {
                        color: colors.greenAccent[300],
                      },
                      "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: colors.blueAccent[800],
                        borderBottom: "none",
                      },
                      "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: colors.primary[400],
                      },
                      "& .MuiDataGrid-footerContainer": {
                        borderTop: "none",
                        backgroundColor: colors.blueAccent[800],
                      },
                      "& .MuiCheckbox-root": {
                        color: `${colors.greenAccent[200]} !important`,
                      },
                      "& .odd-row": {
                        backgroundColor: "",
                        color: "", // Color for odd rows
                      },
                      "& .even-row": {
                        backgroundColor: "#D3D3D3",
                        color: "", // Color for even rows
                      },
                    }}
                  >
                    <DataGrid
                      sx={{
                        "& .MuiDataGrid-footerContainer": {
                          height: dataGridHeaderFooterHeight,
                          minHeight: dataGridHeaderFooterHeight,
                        },
                      }}
                      rows={explorelistViewData}
                      //columns={columns2}
                      columns={newcolumn}
                      disableSelectionOnClick
                      getRowId={(row) => row.RecordID}
                      rowHeight={dataGridRowHeight}
                      headerHeight={dataGridHeaderFooterHeight}
                      pageSize={pageSize}
                      onPageSizeChange={(newPageSize) =>
                        setPageSize(newPageSize)
                      }
                      onCellClick={(params) => {
                        selectCellRowData({
                          rowData: params.row,
                          mode: "E",
                          field: params.field,
                          setFieldValue,
                          type: "service",
                        });
                      }}
                      rowsPerPageOptions={[5, 10, 20]}
                      pagination
                      // components={{
                      //   Toolbar: Employee,
                      // }}
                      components={{
                        Toolbar: () => (
                          <ServiceReset
                            onAdd={() => {
                              selectCellRowData({
                                rowData: {},
                                mode: "A",
                                type: "service",
                                setFieldValue,
                              });
                              resetForm();
                            }}
                          />
                        ),
                      }}
                      onStateChange={(stateParams) =>
                        setRowCount(stateParams.pagination.rowCount)
                      }
                      getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0
                          ? "odd-row"
                          : "even-row"
                      }
                      loading={exploreLoading}
                      componentsProps={{
                        toolbar: {
                          showQuickFilter: true,
                          quickFilterProps: { debounceMs: 500 },
                        },
                      }}
                    />
                  </Box>

                  <FormControl sx={{ gap: formGap }}>
                    <CheckinAutocomplete
                      name="serviceItems"
                      //label="Item"
                      label={
                        <>
                          Item
                          <span style={{ color: "red", fontSize: "20px" }}>
                            *
                          </span>
                        </>
                      }
                      variant="outlined"
                      id="serviceItems"
                      value={values.serviceItems}
                      onChange={(newValue) => {
                        setFieldValue("serviceItems", {
                          RecordID: newValue.RecordID,
                          Code: newValue.Code,
                          Name: newValue.Name,
                        });
                        setFieldTouched("serviceItems", true);
                        setFieldValue(
                          "serviceCategoryID",
                          newValue.CrmItemCategoryID || ""
                        );
                        setFieldValue(
                          "serviceGroupID",
                          newValue.CrmItemGroupID || ""
                        );

                        setFieldValue(
                          "serviceUnit",
                          newValue.ConsumptionUOM || ""
                        );
                        setFieldValue("serviceRate", newValue.Price || "");

                        // Recalculate amount
                        const qty = values.serviceQty || 1;
                        setFieldValue(
                          "serviceAmount",
                          (Number(newValue.Price) * Number(qty)).toFixed(2)
                        );

                        setTimeout(() => {
                          commentsRef.current?.focus();
                        }, 100);

                        console.log(newValue, "--newvalue serviceItems");
                        console.log(newValue.RecordID, "serviceItems RecordID");
                      }}
                      error={!!touched.serviceItems && !!errors.serviceItems}
                      helperText={touched.serviceItems && errors.serviceItems}
                      url={`${listViewurl}?data={"Query":{"AccessID":"2139","ScreenName":"Items","Filter":"CompanyID='${compID}' AND ItemsDesc ='Services'","Any":""}}`}
                    />
                    <TextField
                      fullWidth
                      variant="standard"
                      type="text"
                      value={values.serviceUnit}
                      id="serviceUnit"
                      name="serviceUnit"
                      label="Unit"
                      // label={
                      //   <>
                      //     Unit
                      //     <span style={{ color: "red", fontSize: "20px" }}>
                      //       *
                      //     </span>
                      //   </>
                      // }
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={!!touched.serviceUnit && !!errors.serviceUnit}
                      helperText={touched.serviceUnit && errors.serviceUnit}
                      sx={{
                        backgroundColor: "#ffffff",
                        "& .MuiFilledInput-root": {
                          backgroundColor: "#ffffff",
                        },
                      }}
                      focused
                      InputProps={{
                        readOnly: true,
                      }}
                      inputProps={{ maxLength: 30 }}
                    />

                    <TextField
                      fullWidth
                      variant="standard"
                      type="number"
                      value={values.serviceRate}
                      id="serviceRate"
                      name="serviceRate"
                      label="Rate"
                      // label={
                      //   <>
                      //     Rate
                      //     <span style={{ color: "red", fontSize: "20px" }}>
                      //       *
                      //     </span>
                      //   </>
                      // }
                      onBlur={handleBlur}
                      // onChange={(e) => {
                      //   const rate = e.target.value;
                      //   setFieldValue("serviceRate", rate);

                      //   // Auto update Amount
                      //   const qty = values.serviceQty || 0;
                      //   setFieldValue(
                      //     "serviceAmount",
                      //     (Number(rate) * Number(qty)).toFixed(2)
                      //   );
                      // }}
                      onChange={(e) => {
                        const rate = e.target.value || 0;
                        setFieldValue("serviceRate", rate);

                        const qty = values.serviceQty || 0;
                        setFieldValue("serviceAmount", (qty * rate).toFixed(2));
                      }}
                      error={!!touched.serviceRate && !!errors.serviceRate}
                      helperText={touched.serviceRate && errors.serviceRate}
                      sx={{
                        backgroundColor: "#ffffff",
                        "& .MuiFilledInput-root": {
                          backgroundColor: "#ffffff",
                        },
                      }}
                      focused
                      inputProps={{ maxLength: 90 }}
                      InputProps={{
                        readOnly: true,
                        inputProps: { style: { textAlign: "right" } },
                      }}
                    />

                    <TextField
                      fullWidth
                      variant="standard"
                      type="number"
                      value={values.serviceQty}
                      id="serviceQty"
                      name="serviceQty"
                      label="Quantity"
                      // label={
                      //   <>
                      //     Quantity
                      //     <span style={{ color: "red", fontSize: "20px" }}>
                      //       *
                      //     </span>
                      //   </>
                      // }
                      onBlur={handleBlur}
                      // onChange={(e) => {
                      //   const qty = e.target.value;
                      //   setFieldValue("serviceQty", qty);

                      //   // Auto update Amount
                      //   const rate = values.serviceRate || 0;
                      //   setFieldValue(
                      //     "serviceAmount",
                      //     (Number(rate) * Number(qty)).toFixed(2)
                      //   );
                      // }}
                      onChange={(e) => {
                        const qty = e.target.value;
                        setFieldValue("serviceQty", qty);

                        const rate = values.serviceRate || 0;
                        setFieldValue("serviceAmount", (qty * rate).toFixed(2));
                      }}
                      error={!!touched.serviceQty && !!errors.serviceQty}
                      helperText={touched.serviceQty && errors.serviceQty}
                      sx={{
                        backgroundColor: "#ffffff",
                        "& .MuiFilledInput-root": {
                          backgroundColor: "#ffffff",
                        },
                      }}
                      focused
                      inputProps={{ maxLength: 90 }}
                      InputProps={{
                        inputProps: { style: { textAlign: "right" } },
                      }}
                    />

                    <TextField
                      fullWidth
                      variant="standard"
                      type="number"
                      value={values.serviceAmount}
                      id="serviceAmount"
                      name="serviceAmount"
                      label="Amount"
                      onBlur={handleBlur}
                      inputRef={commentsRef}
                      InputProps={{
                        readOnly: true,
                        inputProps: { style: { textAlign: "right" } },
                      }}
                      error={!!touched.serviceAmount && !!errors.serviceAmount}
                      helperText={touched.serviceAmount && errors.serviceAmount}
                      sx={{
                        backgroundColor: "#ffffff",
                        "& .MuiFilledInput-root": {
                          backgroundColor: "#ffffff",
                        },
                      }}
                      focused
                    />

                    <TextField
                      fullWidth
                      variant="standard"
                      type="text"
                      value={values.servicecomments}
                      id="servicecomments"
                      name="servicecomments"
                      label="Comments"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={
                        !!touched.servicecomments && !!errors.servicecomments
                      }
                      helperText={
                        touched.servicecomments && errors.servicecomments
                      }
                      sx={{
                        //gridColumn: "span 2",
                        backgroundColor: "#ffffff", // Set the background to white
                        "& .MuiFilledInput-root": {
                          backgroundColor: "#ffffff", // Ensure the filled variant also has a white background
                        },
                      }}
                      focused
                      multiline
                      inputProps={{ maxLength: 90 }}
                    />
                    {TaskSource === "Sprint" && (
                      <Box>
                        <Field
                          //  size="small"
                          type="checkbox"
                          name="serviceAdditionalBillable"
                          id="serviceAdditionalBillable"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          as={Checkbox}
                          label="Additionally Billable"
                          sx={{
                            padding: "0px 5px 0px 0px",
                          }}
                        />
                        <FormLabel focused sx={{ color: "black !important" }}>
                          Additionally Billable
                        </FormLabel>
                      </Box>)}
                  </FormControl>
                </Box>
                <Box
                  display="flex"
                  justifyContent="end"
                  padding={1}
                  // style={{ marginTop: "-40px" }}
                  gap={2}
                >
                  {/* {YearFlag == "true" ? ( */}
                  <LoadingButton
                    color="secondary"
                    variant="contained"
                    type="submit"
                    loading={isLoading}
                    disabled={data.TaskSource === "Sprint" && data.Status === "AP"}

                  >
                    Save
                  </LoadingButton>
                  {/* ) : (
                      <Button
                        color="secondary"
                        variant="contained"
                        disabled={true}
                      >
                        Save
                      </Button>
                    )}
                    {YearFlag == "true" ? ( */}
                  <Button
                    color="error"
                    variant="contained"
                    onClick={() => {
                      Swal.fire({
                        title: errorMsgData.Warningmsg.Delete,
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Confirm",
                      }).then((result) => {
                        if (result.isConfirmed) {
                          ServiceSaveFn(values, resetForm, "harddelete");
                        } else {
                          return;
                        }
                      });
                    }}
                    //disabled={funMode == "A"}
                    disabled={funMode === "A" || (data.TaskSource === "Sprint" && data.Status === "AP")}

                  >
                    Delete
                  </Button>
                  {/* ) : (
                      <Button color="error" variant="contained" disabled={true}>
                        Delete
                      </Button>
                    )} */}
                  <Button
                    type="reset"
                    color="warning"
                    variant="contained"
                    onClick={() => {
                      setScreen(0);
                    }}
                  >
                    Cancel
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
        </Paper>
      ) : (
        false
      )}
      {show == "4" ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          <Formik
            initialValues={{
              ...Machineryinitialvalues,
              ...InitialValue
            }}
            enableReinitialize={true}
            validationSchema={validationSchema5}
            onSubmit={(values, { resetForm }) => {
              setTimeout(() => {
                MachinerySaveFn(values, resetForm, false);
              }, 100);
            }}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
              resetForm,
              setFieldValue,
              setFieldTouched,
            }) => (
              <form
                onSubmit={handleSubmit}
                onReset={() => {
                  selectCellRowData({
                    rowData: {},
                    mode: "A",
                    field: "",
                    type: "machinery",
                  });
                  resetForm();
                }} >
                <Box
                  display="grid"
                  gap={formGap}
                  padding={1}
                  gridTemplateColumns="repeat(2 , minMax(0,1fr))"
                  // gap="30px"
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 2",
                    },
                  }}
                >
                  <FormControl sx={{ gap: formGap }}>
                    <TextField
                      name="date"
                      type="date"
                      id="date"
                      label="Date"
                      variant="standard"
                      focused
                      format="MM-DD-YYYY"
                      value={values.date}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={!!touched.date && !!errors.date}
                      helperText={touched.date && errors.date}
                      inputProps={{ readOnly: true }}
                    />

                    <TextField
                      fullWidth
                      variant="standard"
                      type="text"
                      id="description"
                      name="description"
                      value={values.description}
                      label="Title"
                      focused
                      inputProps={{ readOnly: true }}
                    />
                  </FormControl>

                  <Stack
                    sx={{
                      alignContent: "center",
                      justifyContent: "center",
                      alignItems: "center",
                      position: "relative",
                      right: "0px",
                    }}
                  >
                    <Avatar
                      variant="rounded"
                      src={userimg}
                      sx={{ width: "200px", height: "120px" }}
                    />
                  </Stack>

                  <Box
                    m="5px 0 0 0"
                    //height={dataGridHeight}
                    height="50vh"
                    sx={{
                      "& .MuiDataGrid-root": {
                        border: "none",
                      },
                      "& .MuiDataGrid-cell": {
                        borderBottom: "none",
                      },
                      "& .name-column--cell": {
                        color: colors.greenAccent[300],
                      },
                      "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: colors.blueAccent[800],
                        borderBottom: "none",
                      },
                      "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: colors.primary[400],
                      },
                      "& .MuiDataGrid-footerContainer": {
                        borderTop: "none",
                        backgroundColor: colors.blueAccent[800],
                      },
                      "& .MuiCheckbox-root": {
                        color: `${colors.greenAccent[200]} !important`,
                      },
                      "& .odd-row": {
                        backgroundColor: "",
                        color: "", // Color for odd rows
                      },
                      "& .even-row": {
                        backgroundColor: "#D3D3D3",
                        color: "", // Color for even rows
                      },
                    }}
                  >
                    <DataGrid
                      sx={{
                        "& .MuiDataGrid-footerContainer": {
                          height: dataGridHeaderFooterHeight,
                          minHeight: dataGridHeaderFooterHeight,
                        },
                      }}
                      rows={explorelistViewData}
                      columns={newcolumn}
                      // disableSelectionOnClick
                      getRowId={(row) => row.RecordID}
                      rowHeight={dataGridRowHeight}
                      headerHeight={dataGridHeaderFooterHeight}
                      pageSize={pageSize}
                      onPageSizeChange={(newPageSize) =>
                        setPageSize(newPageSize)
                      }
                      onCellClick={(params) => {
                        selectCellRowData({
                          rowData: params.row,
                          mode: "E",
                          field: params.field,
                          setFieldValue,
                          type: "machinery",
                        });
                      }}
                      rowsPerPageOptions={[5, 10, 20]}
                      pagination
                      // components={{
                      //   Toolbar: ProductReset,
                      // }}

                      components={{
                        Toolbar: () => (
                          <MachineryReset
                            onAdd={() => {
                              selectCellRowData({
                                rowData: {},
                                mode: "A",
                                type: "service",
                                setFieldValue,
                              });
                              resetForm();
                            }}
                          />
                        ),
                      }}

                      onStateChange={(stateParams) =>
                        setRowCount(stateParams.pagination.rowCount)
                      }
                      getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0
                          ? "odd-row"
                          : "even-row"
                      }
                      loading={exploreLoading}
                      componentsProps={{
                        toolbar: {
                          showQuickFilter: true,
                          quickFilterProps: { debounceMs: 500 },
                        },
                      }}
                    />
                  </Box>

                  <FormControl sx={{ gap: formGap }}>

                    {/* <Autocomplete
                                options={materials}
                                getOptionLabel={(option) => option.name}
                                onChange={(e, value) => value && handleMaterialSelect(value)}
                                renderInput={(params) => (
                                  <TextField {...params} variant="standard" label="Material" focused />
                                )}
                              />  */}

                    <CheckinAutocomplete
                      name="machineryItems"
                      //label="Item"
                      label={
                        <>
                          Item
                          <span style={{ color: "red", fontSize: "20px" }}> * </span>
                        </>
                      }
                      id="machineryItems"
                      value={values.machineryItems}
                      onChange={(newValue) => {
                        setFieldValue("machineryItems", {
                          RecordID: newValue.RecordID,
                          Code: newValue.Code,
                          Name: newValue.Name,
                        });
                        setFieldTouched("machineryItems", true);
                        setFieldValue("machineryCategoryID", newValue.CrmItemCategoryID || "");
                        setFieldValue("machineryGroupID", newValue.CrmItemGroupID || "");

                        setFieldValue("machineryUnit", newValue.ConsumptionUOM || "");
                        setFieldValue("machineryRate", newValue.Price || "");

                        // Recalculate amount
                        const qty = values.machineryQty || 1;
                        setFieldValue(
                          "machineryAmount",
                          (Number(newValue.Price) * Number(qty)).toFixed(2)
                        );

                        setTimeout(() => {
                          commentsRef.current?.focus();
                        }, 100);

                        console.log(newValue, "--newvalue machineryItems");
                      }}
                      error={!!touched.machineryItems && !!errors.machineryItems}
                      helperText={
                        touched.machineryItems
                          ? typeof errors.machineryItems === "string"
                            ? errors.machineryItems
                            : errors.machineryItems?.RecordID
                          : ""
                      }
                      url={`${listViewurl}?data={"Query":{"AccessID":"2142","ScreenName":"Items","Filter":"CompanyID='76'","Any":""}}`}
                    />
                    <TextField
                      fullWidth
                      variant="standard"
                      type="text"
                      id="machineryUnit"
                      value={values.machineryUnit}
                      name="machineryUnit"
                      label="Unit"
                      sx={{
                        backgroundColor: "#ffffff",
                        "& .MuiFilledInput-root": {
                          backgroundColor: "#ffffff",
                        },
                      }}
                      focused
                      InputProps={{ readOnly: true }}
                      inputProps={{ maxLength: 90 }}
                    />

                    <TextField
                      fullWidth
                      variant="standard"
                      type="number"
                      id="machineryRate"
                      value={values.machineryRate}
                      name="machineryRate"
                      label="Rate"
                      onChange={(e) => {
                        const rate = e.target.value || 0;
                        setFieldValue("machineryRate", rate);

                        const qty = values.machineryQty || 0;
                        setFieldValue("machineryAmount", (qty * rate).toFixed(2));
                      }}
                      sx={{
                        backgroundColor: "#ffffff",
                        "& .MuiFilledInput-root": {
                          backgroundColor: "#ffffff",
                        },
                      }}
                      focused
                      //  InputProps={{ readOnly: true }}
                      InputProps={{
                        readOnly: true,
                        inputProps: {
                          style: { textAlign: 'right', maxLength: 90 },
                        },
                      }}
                    //  InputProps={{
                    />

                    <TextField
                      fullWidth
                      variant="standard"
                      type="number"
                      id="machineryQty"
                      name="machineryQty"
                      value={values.machineryQty}
                      label="Quantity"

                      onBlur={handleBlur}
                      onChange={(e) => {
                        const qty = e.target.value;
                        setFieldValue("machineryQty", qty);

                        const rate = values.machineryRate || 0;
                        setFieldValue("machineryAmount", (qty * rate).toFixed(2));
                      }}
                      sx={{
                        backgroundColor: "#ffffff",
                        "& .MuiFilledInput-root": {
                          backgroundColor: "#ffffff",
                        },
                      }}
                      focused
                      InputProps={{
                        inputProps: {
                          style: { textAlign: 'right', maxLength: 90 },
                        },
                      }}
                    />

                    <TextField
                      fullWidth
                      variant="standard"
                      type="number"
                      id="machineryAmount"
                      name="machineryAmount"
                      value={values.machineryAmount}
                      label="Amount"

                      sx={{
                        backgroundColor: "#ffffff",
                        "& .MuiFilledInput-root": {
                          backgroundColor: "#ffffff",
                        },
                      }}
                      focused
                      InputProps={{
                        inputProps: {
                          style: { textAlign: 'right', },
                        },
                      }}
                    />

                    <TextField
                      fullWidth
                      variant="standard"
                      type="text"
                      id="machineryComments"
                      name="machineryComments"
                      label="Comments"
                      value={values.machineryComments ?? ""}
                      onChange={(e) =>
                        setFieldValue("machineryComments", e.target.value)
                      }
                      sx={{
                        backgroundColor: "#ffffff", // Set the background to white
                        "& .MuiFilledInput-root": {
                          backgroundColor: "#ffffff", // Ensure the filled variant also has a white background
                        },
                      }}
                      focused
                      autoFocus
                      multiline
                      inputProps={{ maxLength: 90 }}
                    />

                    {TaskSource === "Sprint" && (
                      <Box>
                        <Field
                          //  size="small"
                          type="checkbox"
                          name="serviceAdditionalBillable"
                          id="serviceAdditionalBillable"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          as={Checkbox}
                          label="Additionally Billable"
                          sx={{
                            padding: "0px 5px 0px 0px",
                          }}
                        />
                        <FormLabel focused sx={{ color: "black !important" }}>
                          Additionally Billable
                        </FormLabel>
                      </Box>)}

                  </FormControl>
                </Box>
                <Box
                  display="flex"
                  justifyContent="end"
                  padding={1}
                  gap={2}
                >
                  <LoadingButton
                    color="secondary"
                    variant="contained"
                    type="submit"
                    loading={isLoading}
                    disabled={data.TaskSource === "Sprint" && data.Status === "AP"}
                  >
                    Save
                  </LoadingButton>

                  <Button
                    color="error"
                    variant="contained"
                    onClick={() => {
                      Swal.fire({
                        title: errorMsgData.Warningmsg.Delete,
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Confirm",
                      }).then((result) => {
                        if (result.isConfirmed) {
                          MachinerySaveFn(values, resetForm, "harddelete");
                        } else {
                          return;
                        }
                      });
                    }}
                    disabled={funMode === "A" || (data.TaskSource === "Sprint" && data.Status === "AP")}
                  >
                    Delete
                  </Button>

                  <Button
                    type="reset"
                    color="warning"
                    variant="contained"
                    onClick={() => {
                      setScreen(0);
                    }}
                  >
                    Cancel
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
        </Paper>
      ) : (
        false
      )}

    </React.Fragment>
  );
};

export default EditDailytask;
